(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.AngularJSHelpViewer = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var helpViewer = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	    factory(exports) ;
	}(commonjsGlobal, (function (exports) {
	    function noop() { }
	    const identity = x => x;
	    function run(fn) {
	        return fn();
	    }
	    function blank_object() {
	        return Object.create(null);
	    }
	    function run_all(fns) {
	        fns.forEach(run);
	    }
	    function is_function(thing) {
	        return typeof thing === 'function';
	    }
	    function safe_not_equal(a, b) {
	        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	    }
	    function is_empty(obj) {
	        return Object.keys(obj).length === 0;
	    }
	    function subscribe(store, ...callbacks) {
	        if (store == null) {
	            return noop;
	        }
	        const unsub = store.subscribe(...callbacks);
	        return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
	    }
	    function component_subscribe(component, store, callback) {
	        component.$$.on_destroy.push(subscribe(store, callback));
	    }

	    const is_client = typeof window !== 'undefined';
	    let now = is_client
	        ? () => window.performance.now()
	        : () => Date.now();
	    let raf = is_client ? cb => requestAnimationFrame(cb) : noop;

	    const tasks = new Set();
	    function run_tasks(now) {
	        tasks.forEach(task => {
	            if (!task.c(now)) {
	                tasks.delete(task);
	                task.f();
	            }
	        });
	        if (tasks.size !== 0)
	            raf(run_tasks);
	    }
	    /**
	     * Creates a new task that runs on each raf frame
	     * until it returns a falsy value or is aborted
	     */
	    function loop(callback) {
	        let task;
	        if (tasks.size === 0)
	            raf(run_tasks);
	        return {
	            promise: new Promise(fulfill => {
	                tasks.add(task = { c: callback, f: fulfill });
	            }),
	            abort() {
	                tasks.delete(task);
	            }
	        };
	    }

	    function append(target, node) {
	        target.appendChild(node);
	    }
	    function insert(target, node, anchor) {
	        target.insertBefore(node, anchor || null);
	    }
	    function detach(node) {
	        node.parentNode.removeChild(node);
	    }
	    function element(name) {
	        return document.createElement(name);
	    }
	    function svg_element(name) {
	        return document.createElementNS('http://www.w3.org/2000/svg', name);
	    }
	    function text(data) {
	        return document.createTextNode(data);
	    }
	    function space() {
	        return text(' ');
	    }
	    function empty() {
	        return text('');
	    }
	    function listen(node, event, handler, options) {
	        node.addEventListener(event, handler, options);
	        return () => node.removeEventListener(event, handler, options);
	    }
	    function attr(node, attribute, value) {
	        if (value == null)
	            node.removeAttribute(attribute);
	        else if (node.getAttribute(attribute) !== value)
	            node.setAttribute(attribute, value);
	    }
	    function children(element) {
	        return Array.from(element.childNodes);
	    }
	    function set_data(text, data) {
	        data = '' + data;
	        if (text.wholeText !== data)
	            text.data = data;
	    }
	    function toggle_class(element, name, toggle) {
	        element.classList[toggle ? 'add' : 'remove'](name);
	    }
	    function custom_event(type, detail) {
	        const e = document.createEvent('CustomEvent');
	        e.initCustomEvent(type, false, false, detail);
	        return e;
	    }
	    class HtmlTag {
	        constructor(anchor = null) {
	            this.a = anchor;
	            this.e = this.n = null;
	        }
	        m(html, target, anchor = null) {
	            if (!this.e) {
	                this.e = element(target.nodeName);
	                this.t = target;
	                this.h(html);
	            }
	            this.i(anchor);
	        }
	        h(html) {
	            this.e.innerHTML = html;
	            this.n = Array.from(this.e.childNodes);
	        }
	        i(anchor) {
	            for (let i = 0; i < this.n.length; i += 1) {
	                insert(this.t, this.n[i], anchor);
	            }
	        }
	        p(html) {
	            this.d();
	            this.h(html);
	            this.i(this.a);
	        }
	        d() {
	            this.n.forEach(detach);
	        }
	    }

	    const active_docs = new Set();
	    let active = 0;
	    // https://github.com/darkskyapp/string-hash/blob/master/index.js
	    function hash(str) {
	        let hash = 5381;
	        let i = str.length;
	        while (i--)
	            hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
	        return hash >>> 0;
	    }
	    function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
	        const step = 16.666 / duration;
	        let keyframes = '{\n';
	        for (let p = 0; p <= 1; p += step) {
	            const t = a + (b - a) * ease(p);
	            keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
	        }
	        const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
	        const name = `__svelte_${hash(rule)}_${uid}`;
	        const doc = node.ownerDocument;
	        active_docs.add(doc);
	        const stylesheet = doc.__svelte_stylesheet || (doc.__svelte_stylesheet = doc.head.appendChild(element('style')).sheet);
	        const current_rules = doc.__svelte_rules || (doc.__svelte_rules = {});
	        if (!current_rules[name]) {
	            current_rules[name] = true;
	            stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
	        }
	        const animation = node.style.animation || '';
	        node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
	        active += 1;
	        return name;
	    }
	    function delete_rule(node, name) {
	        const previous = (node.style.animation || '').split(', ');
	        const next = previous.filter(name
	            ? anim => anim.indexOf(name) < 0 // remove specific animation
	            : anim => anim.indexOf('__svelte') === -1 // remove all Svelte animations
	        );
	        const deleted = previous.length - next.length;
	        if (deleted) {
	            node.style.animation = next.join(', ');
	            active -= deleted;
	            if (!active)
	                clear_rules();
	        }
	    }
	    function clear_rules() {
	        raf(() => {
	            if (active)
	                return;
	            active_docs.forEach(doc => {
	                const stylesheet = doc.__svelte_stylesheet;
	                let i = stylesheet.cssRules.length;
	                while (i--)
	                    stylesheet.deleteRule(i);
	                doc.__svelte_rules = {};
	            });
	            active_docs.clear();
	        });
	    }

	    let current_component;
	    function set_current_component(component) {
	        current_component = component;
	    }
	    function get_current_component() {
	        if (!current_component)
	            throw new Error('Function called outside component initialization');
	        return current_component;
	    }
	    function beforeUpdate(fn) {
	        get_current_component().$$.before_update.push(fn);
	    }
	    function onMount(fn) {
	        get_current_component().$$.on_mount.push(fn);
	    }
	    function onDestroy(fn) {
	        get_current_component().$$.on_destroy.push(fn);
	    }
	    function createEventDispatcher() {
	        const component = get_current_component();
	        return (type, detail) => {
	            const callbacks = component.$$.callbacks[type];
	            if (callbacks) {
	                // TODO are there situations where events could be dispatched
	                // in a server (non-DOM) environment?
	                const event = custom_event(type, detail);
	                callbacks.slice().forEach(fn => {
	                    fn.call(component, event);
	                });
	            }
	        };
	    }

	    const dirty_components = [];
	    const binding_callbacks = [];
	    const render_callbacks = [];
	    const flush_callbacks = [];
	    const resolved_promise = Promise.resolve();
	    let update_scheduled = false;
	    function schedule_update() {
	        if (!update_scheduled) {
	            update_scheduled = true;
	            resolved_promise.then(flush);
	        }
	    }
	    function add_render_callback(fn) {
	        render_callbacks.push(fn);
	    }
	    function add_flush_callback(fn) {
	        flush_callbacks.push(fn);
	    }
	    let flushing = false;
	    const seen_callbacks = new Set();
	    function flush() {
	        if (flushing)
	            return;
	        flushing = true;
	        do {
	            // first, call beforeUpdate functions
	            // and update components
	            for (let i = 0; i < dirty_components.length; i += 1) {
	                const component = dirty_components[i];
	                set_current_component(component);
	                update(component.$$);
	            }
	            set_current_component(null);
	            dirty_components.length = 0;
	            while (binding_callbacks.length)
	                binding_callbacks.pop()();
	            // then, once components are updated, call
	            // afterUpdate functions. This may cause
	            // subsequent updates...
	            for (let i = 0; i < render_callbacks.length; i += 1) {
	                const callback = render_callbacks[i];
	                if (!seen_callbacks.has(callback)) {
	                    // ...so guard against infinite loops
	                    seen_callbacks.add(callback);
	                    callback();
	                }
	            }
	            render_callbacks.length = 0;
	        } while (dirty_components.length);
	        while (flush_callbacks.length) {
	            flush_callbacks.pop()();
	        }
	        update_scheduled = false;
	        flushing = false;
	        seen_callbacks.clear();
	    }
	    function update($$) {
	        if ($$.fragment !== null) {
	            $$.update();
	            run_all($$.before_update);
	            const dirty = $$.dirty;
	            $$.dirty = [-1];
	            $$.fragment && $$.fragment.p($$.ctx, dirty);
	            $$.after_update.forEach(add_render_callback);
	        }
	    }

	    let promise;
	    function wait() {
	        if (!promise) {
	            promise = Promise.resolve();
	            promise.then(() => {
	                promise = null;
	            });
	        }
	        return promise;
	    }
	    function dispatch(node, direction, kind) {
	        node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
	    }
	    const outroing = new Set();
	    let outros;
	    function group_outros() {
	        outros = {
	            r: 0,
	            c: [],
	            p: outros // parent group
	        };
	    }
	    function check_outros() {
	        if (!outros.r) {
	            run_all(outros.c);
	        }
	        outros = outros.p;
	    }
	    function transition_in(block, local) {
	        if (block && block.i) {
	            outroing.delete(block);
	            block.i(local);
	        }
	    }
	    function transition_out(block, local, detach, callback) {
	        if (block && block.o) {
	            if (outroing.has(block))
	                return;
	            outroing.add(block);
	            outros.c.push(() => {
	                outroing.delete(block);
	                if (callback) {
	                    if (detach)
	                        block.d(1);
	                    callback();
	                }
	            });
	            block.o(local);
	        }
	    }
	    const null_transition = { duration: 0 };
	    function create_bidirectional_transition(node, fn, params, intro) {
	        let config = fn(node, params);
	        let t = intro ? 0 : 1;
	        let running_program = null;
	        let pending_program = null;
	        let animation_name = null;
	        function clear_animation() {
	            if (animation_name)
	                delete_rule(node, animation_name);
	        }
	        function init(program, duration) {
	            const d = program.b - t;
	            duration *= Math.abs(d);
	            return {
	                a: t,
	                b: program.b,
	                d,
	                duration,
	                start: program.start,
	                end: program.start + duration,
	                group: program.group
	            };
	        }
	        function go(b) {
	            const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
	            const program = {
	                start: now() + delay,
	                b
	            };
	            if (!b) {
	                // @ts-ignore todo: improve typings
	                program.group = outros;
	                outros.r += 1;
	            }
	            if (running_program || pending_program) {
	                pending_program = program;
	            }
	            else {
	                // if this is an intro, and there's a delay, we need to do
	                // an initial tick and/or apply CSS animation immediately
	                if (css) {
	                    clear_animation();
	                    animation_name = create_rule(node, t, b, duration, delay, easing, css);
	                }
	                if (b)
	                    tick(0, 1);
	                running_program = init(program, duration);
	                add_render_callback(() => dispatch(node, b, 'start'));
	                loop(now => {
	                    if (pending_program && now > pending_program.start) {
	                        running_program = init(pending_program, duration);
	                        pending_program = null;
	                        dispatch(node, running_program.b, 'start');
	                        if (css) {
	                            clear_animation();
	                            animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
	                        }
	                    }
	                    if (running_program) {
	                        if (now >= running_program.end) {
	                            tick(t = running_program.b, 1 - t);
	                            dispatch(node, running_program.b, 'end');
	                            if (!pending_program) {
	                                // we're done
	                                if (running_program.b) {
	                                    // intro — we can tidy up immediately
	                                    clear_animation();
	                                }
	                                else {
	                                    // outro — needs to be coordinated
	                                    if (!--running_program.group.r)
	                                        run_all(running_program.group.c);
	                                }
	                            }
	                            running_program = null;
	                        }
	                        else if (now >= running_program.start) {
	                            const p = now - running_program.start;
	                            t = running_program.a + running_program.d * easing(p / running_program.duration);
	                            tick(t, 1 - t);
	                        }
	                    }
	                    return !!(running_program || pending_program);
	                });
	            }
	        }
	        return {
	            run(b) {
	                if (is_function(config)) {
	                    wait().then(() => {
	                        // @ts-ignore
	                        config = config();
	                        go(b);
	                    });
	                }
	                else {
	                    go(b);
	                }
	            },
	            end() {
	                clear_animation();
	                running_program = pending_program = null;
	            }
	        };
	    }

	    function bind(component, name, callback) {
	        const index = component.$$.props[name];
	        if (index !== undefined) {
	            component.$$.bound[index] = callback;
	            callback(component.$$.ctx[index]);
	        }
	    }
	    function create_component(block) {
	        block && block.c();
	    }
	    function mount_component(component, target, anchor, customElement) {
	        const { fragment, on_mount, on_destroy, after_update } = component.$$;
	        fragment && fragment.m(target, anchor);
	        if (!customElement) {
	            // onMount happens before the initial afterUpdate
	            add_render_callback(() => {
	                const new_on_destroy = on_mount.map(run).filter(is_function);
	                if (on_destroy) {
	                    on_destroy.push(...new_on_destroy);
	                }
	                else {
	                    // Edge case - component was destroyed immediately,
	                    // most likely as a result of a binding initialising
	                    run_all(new_on_destroy);
	                }
	                component.$$.on_mount = [];
	            });
	        }
	        after_update.forEach(add_render_callback);
	    }
	    function destroy_component(component, detaching) {
	        const $$ = component.$$;
	        if ($$.fragment !== null) {
	            run_all($$.on_destroy);
	            $$.fragment && $$.fragment.d(detaching);
	            // TODO null out other refs, including component.$$ (but need to
	            // preserve final state?)
	            $$.on_destroy = $$.fragment = null;
	            $$.ctx = [];
	        }
	    }
	    function make_dirty(component, i) {
	        if (component.$$.dirty[0] === -1) {
	            dirty_components.push(component);
	            schedule_update();
	            component.$$.dirty.fill(0);
	        }
	        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	    }
	    function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
	        const parent_component = current_component;
	        set_current_component(component);
	        const $$ = component.$$ = {
	            fragment: null,
	            ctx: null,
	            // state
	            props,
	            update: noop,
	            not_equal,
	            bound: blank_object(),
	            // lifecycle
	            on_mount: [],
	            on_destroy: [],
	            on_disconnect: [],
	            before_update: [],
	            after_update: [],
	            context: new Map(parent_component ? parent_component.$$.context : options.context || []),
	            // everything else
	            callbacks: blank_object(),
	            dirty,
	            skip_bound: false
	        };
	        let ready = false;
	        $$.ctx = instance
	            ? instance(component, options.props || {}, (i, ret, ...rest) => {
	                const value = rest.length ? rest[0] : ret;
	                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                    if (!$$.skip_bound && $$.bound[i])
	                        $$.bound[i](value);
	                    if (ready)
	                        make_dirty(component, i);
	                }
	                return ret;
	            })
	            : [];
	        $$.update();
	        ready = true;
	        run_all($$.before_update);
	        // `false` as a special case of no DOM component
	        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	        if (options.target) {
	            if (options.hydrate) {
	                const nodes = children(options.target);
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.l(nodes);
	                nodes.forEach(detach);
	            }
	            else {
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.c();
	            }
	            if (options.intro)
	                transition_in(component.$$.fragment);
	            mount_component(component, options.target, options.anchor, options.customElement);
	            flush();
	        }
	        set_current_component(parent_component);
	    }
	    /**
	     * Base class for Svelte components. Used when dev=false.
	     */
	    class SvelteComponent {
	        $destroy() {
	            destroy_component(this, 1);
	            this.$destroy = noop;
	        }
	        $on(type, callback) {
	            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	            callbacks.push(callback);
	            return () => {
	                const index = callbacks.indexOf(callback);
	                if (index !== -1)
	                    callbacks.splice(index, 1);
	            };
	        }
	        $set($$props) {
	            if (this.$$set && !is_empty($$props)) {
	                this.$$.skip_bound = true;
	                this.$$set($$props);
	                this.$$.skip_bound = false;
	            }
	        }
	    }

	    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	    function getDefaultExportFromCjs (x) {
	    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	    }

	    function createCommonjsModule(fn, basedir, module) {
	    	return module = {
	    		path: basedir,
	    		exports: {},
	    		require: function (path, base) {
	    			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
	    		}
	    	}, fn(module, module.exports), module.exports;
	    }

	    function getAugmentedNamespace(n) {
	    	if (n.__esModule) return n;
	    	var a = Object.defineProperty({}, '__esModule', {value: true});
	    	Object.keys(n).forEach(function (k) {
	    		var d = Object.getOwnPropertyDescriptor(n, k);
	    		Object.defineProperty(a, k, d.get ? d : {
	    			enumerable: true,
	    			get: function () {
	    				return n[k];
	    			}
	    		});
	    	});
	    	return a;
	    }

	    function commonjsRequire () {
	    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	    }

	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise */

	    var extendStatics$1 = function(d, b) {
	        extendStatics$1 = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics$1(d, b);
	    };

	    function __extends$1(d, b) {
	        extendStatics$1(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign$1 = function() {
	        __assign$1 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$1.apply(this, arguments);
	    };

	    function __rest(s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    }

	    function __decorate(decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    }

	    function __param(paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    }

	    function __metadata(metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    }

	    function __awaiter(thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    }

	    function __generator(thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    }

	    var __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });

	    function __exportStar(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    }

	    function __values(o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    }

	    function __read(o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    }

	    function __spread() {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    }

	    function __spreadArrays() {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    }
	    function __await(v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    }

	    function __asyncGenerator(thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    }

	    function __asyncDelegator(o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    }

	    function __asyncValues(o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    }

	    function __makeTemplateObject(cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    }
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };

	    function __importStar(mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    }

	    function __importDefault(mod) {
	        return (mod && mod.__esModule) ? mod : { default: mod };
	    }

	    function __classPrivateFieldGet(receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    }

	    function __classPrivateFieldSet(receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    }

	    var tslib_es6 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        __extends: __extends$1,
	        get __assign () { return __assign$1; },
	        __rest: __rest,
	        __decorate: __decorate,
	        __param: __param,
	        __metadata: __metadata,
	        __awaiter: __awaiter,
	        __generator: __generator,
	        __createBinding: __createBinding,
	        __exportStar: __exportStar,
	        __values: __values,
	        __read: __read,
	        __spread: __spread,
	        __spreadArrays: __spreadArrays,
	        __await: __await,
	        __asyncGenerator: __asyncGenerator,
	        __asyncDelegator: __asyncDelegator,
	        __asyncValues: __asyncValues,
	        __makeTemplateObject: __makeTemplateObject,
	        __importStar: __importStar,
	        __importDefault: __importDefault,
	        __classPrivateFieldGet: __classPrivateFieldGet,
	        __classPrivateFieldSet: __classPrivateFieldSet
	    });

	    var Cache_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    /**
	     * Simple cache implementation
	     */
	    var Cache = /** @class */ (function () {
	        function Cache() {
	            this.data = {};
	            this.pending = {};
	        }
	        Cache.prototype.put = function (key, value) {
	            var previousValue = this.data[key];
	            this.data[key] = value;
	            return previousValue;
	        };
	        Cache.prototype.get = function (key) {
	            return this.data[key];
	        };
	        Cache.prototype.remove = function (key) {
	            var previousValue = this.data[key];
	            delete this.data[key];
	            return previousValue;
	        };
	        Cache.prototype.removeAll = function () {
	            this.data = {};
	        };
	        /**
	         * Gets a value from the cache or invokes the callback to populate the value
	         * with the result of a promise. If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refreshIfAbsent = function (key, callback) {
	            if (this.data.hasOwnProperty(key)) {
	                return Promise.resolve(this.data[key]);
	            }
	            return this.refresh(key, callback);
	        };
	        /**
	         * Invokes the callback to populate the value with the result of a promise.
	         * If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refresh = function (key, callback) {
	            var _this = this;
	            // Check if the callback is already pending for this key
	            var pending = this.pending[key];
	            if (pending) {
	                return pending;
	            }
	            pending = callback();
	            this.pending[key] = pending;
	            return pending.then(function (value) {
	                delete _this.pending[key];
	                _this.put(key, value);
	                return value;
	            }).catch(function (error) {
	                delete _this.pending[key];
	                throw error;
	            });
	        };
	        return Cache;
	    }());
	    exports.default = Cache;

	    });

	    var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

	    var Registry_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.SERVICE_REGISTRY_PATH = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
	    var PORTAL_SERVICE_NAME = 'portal_service';
	    var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
	    var DEFAULT_CONFIG = {
	        host: '',
	        cache: new Cache_1$1.default(),
	    };
	    var Registry = /** @class */ (function () {
	        function Registry(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        // Get the underlying registry cache
	        Registry.prototype.getCache = function () {
	            return this.config.cache;
	        };
	        Registry.prototype.getRegistry = function () {
	            var _this = this;
	            return this.config.cache.refreshIfAbsent('registry', function () {
	                var serviceRegistryUrl = _this.getHost();
	                serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
	                var config = {
	                    method: 'GET',
	                    mode: 'cors',
	                    credentials: 'include',
	                    headers: {
	                        'Content-Type': 'application/json',
	                    },
	                };
	                return fetch(serviceRegistryUrl, config).then(function (resp) {
	                    if (!resp.ok) {
	                        return Promise.reject(resp);
	                    }
	                    return resp.json().then(function (data) {
	                        var dataResponse = tslib_1.__assign({ data: data }, resp);
	                        var registry = data.registry;
	                        // Optimization - also stuff the client config URL into the cache.
	                        // Sometimes, this URL can be different if it's requested from the same domain.
	                        var portalService = registry.services[PORTAL_SERVICE_NAME];
	                        if (portalService) {
	                            var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
	                            _this.config.cache.put(clientConfigUrl, dataResponse);
	                        }
	                        return dataResponse;
	                    });
	                });
	            }).then(function (resp) {
	                return resp.data.registry;
	            });
	        };
	        Registry.prototype.getUrl = function (serviceName, path, version) {
	            var _this = this;
	            if (path === void 0) { path = ''; }
	            return this.getRegistry().then(function (data) {
	                var service = data.services[serviceName];
	                if (service === undefined) {
	                    throw new Error("Unable to find service '" + serviceName + "'");
	                }
	                return service;
	            }).then(function (service) {
	                return _this.createServiceUrl(service, path, version);
	            });
	        };
	        Registry.prototype.getServiceBaseUrl = function (service, version) {
	            var baseUrl = service.base_sv_url;
	            if (!baseUrl) {
	                // unversioned service - simply return regular service url
	                return service.sv_url;
	            }
	            if (version === undefined) {
	                // Use configured version if present
	                // if(apiVersions[serviceName]) {
	                //  version = apiVersions[serviceName];
	                // Fallback to version 1 (keeps backwards comparability and generally safe)
	                version = 1;
	            }
	            return this.joinUrlParts(baseUrl, 'v' + version);
	        };
	        Registry.prototype.getServiceHostUrl = function (service) {
	            // Inspired by https://gist.github.com/jlong/2428561
	            var parser = document.createElement('a');
	            parser.href = service.sv_url;
	            return parser.protocol + "//" + parser.host;
	        };
	        Registry.prototype.createServiceUrl = function (service, path, version) {
	            var base;
	            if (path.charAt(0) === '/') {
	                // Host absolute URL
	                base = this.getServiceHostUrl(service);
	            }
	            else {
	                // Service relative URL
	                base = this.getServiceBaseUrl(service, version);
	            }
	            return this.joinUrlParts(base, path);
	        };
	        /**
	         * Determines the registry host in the following order,
	         * 1. Uses the configured host if set
	         * 2. If a PrintOS subdomain is detected as the current hostname,
	         *    the base domain is returned.
	         *    For example, if location.hostname is 'app.www.printos.com',
	         *    then 'www.printos.com' is returned.
	         * 3. Return an empty string otherwise (resulting in a registry call relative
	         *    to the current host).
	         */
	        Registry.prototype.getHost = function () {
	            if (this.config.host) {
	                // Ensure https
	                if (this.config.host.indexOf('https://') !== 0) {
	                    this.config.host = 'https://' + this.config.host;
	                }
	                return this.config.host;
	            }
	            return '';
	        };
	        Registry.prototype.joinUrlParts = function (a, b) {
	            if (!b) {
	                return a;
	            }
	            if (b.charAt(0) === '/') {
	                // Prevent double slashes by ensuring part b doesn't have a slash
	                b = b.substr(1);
	            }
	            if (a.charAt(a.length - 1) === '/') {
	                return a + b;
	            }
	            return a + '/' + b;
	        };
	        return Registry;
	    }());
	    exports.default = Registry;

	    });

	    var Http_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var DEFAULT_CONFIG = {
	        registry: new Registry_1$1.default(),
	    };
	    var Http = /** @class */ (function () {
	        function Http(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	            // Use registry cache by default to cache the registry efficiently
	            // Use registry cache by default to cache the registry efficiently
	            this.config.cache = this.config.cache || this.config.registry.getCache();
	        }
	        Http.prototype.getCookie = function (name) {
	            var value = "; " + document.cookie;
	            var parts = value.split("; " + name + "=");
	            if (parts.length == 2) {
	                return decodeURIComponent(parts.pop().split(';').shift());
	            }
	        };
	        Http.prototype.fetchJsonResponse = function (config) {
	            var _this = this;
	            var url = Http.formatUrl(config);
	            var fetchConfig = {
	                method: config.method,
	                mode: config.mode ? config.mode : 'cors',
	                credentials: config.credentials ? config.credentials : 'include',
	                headers: {},
	            };
	            // if (fetchConfig.credentials === 'include') {
	            //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
	            //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
	            //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
	            //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
	            // }
	            if (config.data !== undefined && config.data !== null) {
	                if (config.data instanceof FormData) {
	                    fetchConfig.body = config.data;
	                    // fetchConfig.headers['Content-Type'] = undefined;
	                    fetchConfig.headers['Accept'] = '*/*';
	                }
	                else {
	                    fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
	                    fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
	                    fetchConfig.headers['Content-Type'] = 'application/json';
	                    // XSRF-TOKEN handling
	                    var xsrfToken = this.getCookie('XSRF-TOKEN');
	                    if (xsrfToken) {
	                        fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
	                    }
	                }
	            }
	            // Add or overwrite any headers that were passed in
	            fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
	            // Clean up any undefined or null values from the object if explicitly set
	            for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
	                var _b = _a[_i], key = _b[0], value = _b[1];
	                if (value === undefined || value === null) {
	                    delete fetchConfig.headers[key];
	                }
	            }
	            return fetch(url, fetchConfig).then(function (resp) {
	                if (_this.responseInterceptor) {
	                    return _this.responseInterceptor(resp);
	                }
	                return resp;
	            }).then(function (resp) {
	                var _a, _b;
	                if (!resp.ok) {
	                    if ((_a = resp.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
	                        return resp.json().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    if ((_b = resp.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('text/plain')) {
	                        return resp.text().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    return Promise.reject(Object.assign(resp, { data: null }));
	                }
	                if (resp.status === 204) {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                if (fetchConfig.method === 'HEAD') {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                var contentType = resp.headers.get('Content-Type');
	                if (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) {
	                    return resp.json().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    })
	                        .catch(function (e) {
	                        console.warn('HTTP: Failed to parse JSON response', e);
	                        return Object.assign(resp, { data: null });
	                    });
	                }
	                if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('text/plain')) || config.responseType === 'text') {
	                    return resp.text().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    });
	                }
	                return Promise.resolve(Object.assign(resp));
	            });
	        };
	        Http.formatUrl = function (config) {
	            var url = config.url;
	            if (config.params) {
	                if (url.includes('?')) {
	                    url += '&';
	                }
	                else {
	                    url += '?';
	                }
	                url += Http.getQueryString(config.params);
	            }
	            return url;
	        };
	        // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
	        Http.getQueryString = function (params) {
	            return Object.keys(params).map(function (k) {
	                var param = params[k];
	                if (Array.isArray(param)) {
	                    return param
	                        .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
	                        .join('&');
	                }
	                return encodeURIComponent(k) + "=" + encodeURIComponent(param);
	            }).join('&');
	        };
	        Http.prototype.request = function (config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            if (config.cache === true) {
	                return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            if (config.cache === 'refresh') {
	                return this.config.cache.refresh(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            return this.fetchJsonResponse(config);
	        };
	        Http.prototype.serviceRequest = function (serviceName, path, config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
	                config.url = url;
	                return _this.request(config);
	            });
	        };
	        //
	        // Shortcut methods
	        //
	        Http.prototype.get = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'GET';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.post = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'POST';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.put = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PUT';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.patch = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PATCH';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.delete = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'DELETE';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.head = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'HEAD';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.fetch = function (url, config) {
	            if (config === void 0) { config = {}; }
	            config.url = url;
	            return this.fetchJsonResponse(config);
	        };
	        return Http;
	    }());
	    exports.default = Http;

	    });

	    var Preferences_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var DEFAULT_CONFIG = {
	        http: new Http_1$1.default(),
	    };
	    var Preferences = /** @class */ (function () {
	        function Preferences(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        Preferences.prototype.get = function (path, cache) {
	            if (path === void 0) { path = null; }
	            if (cache === void 0) { cache = true; }
	            var reqPath = 'preferences';
	            if (path) {
	                reqPath += '/' + path;
	            }
	            return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.update = function (prefs) {
	            return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.patch = function (path, prefs) {
	            return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.delete = function (path) {
	            return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.deleteAll = function () {
	            return this.config.http.delete('portal_service', 'preferences', { version: 2 });
	        };
	        return Preferences;
	    }());
	    exports.default = Preferences;

	    });

	    var Locale_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var Locale = /** @class */ (function () {
	        function Locale() {
	            this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
	        }
	        Locale.prototype.getCookieValue = function (cookieName) {
	            var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
	            if (match) {
	                return decodeURIComponent(match[2]);
	            }
	            return null;
	        };
	        Locale.prototype.getBestFit = function () {
	            var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
	            if (cookie && cookie.locale) {
	                return cookie.locale.split('-')[0];
	            }
	            return window.navigator.language.split('-')[0];
	        };
	        return Locale;
	    }());
	    exports.default = Locale;

	    });

	    var dist = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
	    var Locale_1$1 = tslib_1.__importDefault(Locale_1);
	    // TODO: move into Registry and have it listen for blue ready
	    function getRegistryHost() {
	        var host = '';
	        if (window.printos &&
	            window.printos.blue &&
	            window.printos.blue.ui &&
	            window.printos.blue.ui.registry) {
	            host = window.printos.blue.ui.registry.host;
	        }
	        return host;
	    }
	    exports.cache = new Cache_1$1.default();
	    exports.registry = new Registry_1$1.default({
	        cache: exports.cache,
	        host: getRegistryHost(),
	    });
	    exports.http = new Http_1$1.default({
	        cache: exports.cache,
	        registry: exports.registry
	    });
	    exports.preferences = new Preferences_1$1.default({ http: exports.http });
	    exports.locale = new Locale_1$1.default();
	    exports.default = {
	        cache: exports.cache,
	        registry: exports.registry,
	        http: exports.http,
	        preferences: exports.preferences,
	        locale: exports.locale,
	    };

	    });

	    var core = /*@__PURE__*/getDefaultExportFromCjs(dist);

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/icon/src/Icon.svelte generated by Svelte v3.38.2 */

	    function add_css$3() {
	    	var style = element("style");
	    	style.id = "svelte-1if0avd-style";
	    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	    	append(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$4(ctx) {
	    	let html_tag;
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(/*_content*/ ctx[1], target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    function create_fragment$4(ctx) {
	    	let div1;
	    	let div0;
	    	let div0_pros_tooltip_value;
	    	let div1_class_value;
	    	let if_block = /*_content*/ ctx[1] && create_if_block$4(ctx);

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			if (if_block) if_block.c();
	    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
	    			attr(div0, "style", /*_style*/ ctx[4]);
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
	    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
	    			attr(div1, "style", /*_style*/ ctx[4]);
	    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			if (if_block) if_block.m(div0, null);
	    			/*div1_binding*/ ctx[22](div1);
	    		},
	    		p(ctx, [dirty]) {
	    			if (/*_content*/ ctx[1]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block$4(ctx);
	    					if_block.c();
	    					if_block.m(div0, null);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div0, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
	    				attr(div1, "class", div1_class_value);
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div1, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*_theme*/ 4) {
	    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			}

	    			if (dirty & /*mode*/ 1) {
	    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			}

	    			if (dirty & /*_className, disabled*/ 136) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			if (if_block) if_block.d();
	    			/*div1_binding*/ ctx[22](null);
	    		}
	    	};
	    }

	    function hasValue$3(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$4($$self, $$props, $$invalidate) {
	    	createEventDispatcher();
	    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { mode = "default" } = $$props; // default/form
	    	let { className = "" } = $$props; // Class name
	    	let { tooltip } = $$props;
	    	let { disabled = false } = $$props;
	    	let { size = "24px" } = $$props;
	    	let { constraint = "h" } = $$props;
	    	let { color } = $$props;
	    	let { solid = false } = $$props;
	    	let { _content = undefined } = $$props;
	    	let { _theme } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _className } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _iconElement = undefined } = $$props;
	    	let { _lastName = null } = $$props;
	    	let { _lastPath = null } = $$props;
	    	let { _lastUrl = null } = $$props;

	    	onMount(() => {
	    		$$invalidate(3, _className = hasValue$3(className) ? className : "");
	    		updateContent();
	    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	    	beforeUpdate(() => {
	    		$$invalidate(8, theme = hasValue$3(theme) ? theme : "light");
	    		$$invalidate(0, mode = hasValue$3(mode) ? mode : "icon");

	    		if (theme !== _lastTheme) {
	    			$$invalidate(9, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(2, _theme = theme);
	    			}
	    		}

	    		if (name !== _lastName) {
	    			$$invalidate(10, _lastName = name);
	    			updateContent();
	    		}

	    		if (path !== _lastPath) {
	    			$$invalidate(11, _lastPath = path);
	    			updateContent();
	    		}

	    		if (url !== _lastUrl) {
	    			$$invalidate(12, _lastUrl = url);
	    			updateContent();
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function updateContent() {
	    		if (name) {
	    			let myName = solid ? name : `${name}-o`;
	    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	    		} else if (path) {
	    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	    		} else if (url) {
	    			loadContent.call(this, url);
	    		}
	    	}

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(2, _theme = event.detail.theme);
	    		}
	    	}

	    	// Others
	    	function loadContent(url) {
	    		let config = {
	    			url,
	    			cache: true,
	    			credentials: "omit",
	    			responseType: "text"
	    		};

	    		return dist.http.request(config).then(resp => {
	    			$$invalidate(1, _content = resp.data);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_iconElement = $$value;
	    			$$invalidate(5, _iconElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
	    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
	    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
	    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
	    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
	    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
	    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
	    			// onState
	    			{
	    				if (size) {
	    					let h;
	    					let w;

	    					switch (constraint) {
	    						case "b":
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = isNaN(size) ? size : `${size}px`;
	    							break;
	    						case "w":
	    							w = isNaN(size) ? size : `${size}px`;
	    							h = "fit-content";
	    							break;
	    						case "h":
	    						default:
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = "fit-content";
	    							break;
	    					}

	    					$$invalidate(4, _style = `height:${h};width:${w};`);
	    				}

	    				if (color) {
	    					if (hasValue$3(color)) {
	    						$$invalidate(4, _style += `color:${color};fill:${color}`);
	    					}
	    				}
	    			}
	    		}
	    	};

	    	return [
	    		mode,
	    		_content,
	    		_theme,
	    		_className,
	    		_style,
	    		_iconElement,
	    		tooltip,
	    		disabled,
	    		theme,
	    		_lastTheme,
	    		_lastName,
	    		_lastPath,
	    		_lastUrl,
	    		name,
	    		path,
	    		url,
	    		className,
	    		size,
	    		constraint,
	    		color,
	    		solid,
	    		hasValue$3,
	    		div1_binding
	    	];
	    }

	    class Icon$1 extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1if0avd-style")) add_css$3();

	    		init(this, options, instance$4, create_fragment$4, safe_not_equal, {
	    			name: 13,
	    			path: 14,
	    			url: 15,
	    			theme: 8,
	    			mode: 0,
	    			className: 16,
	    			tooltip: 6,
	    			disabled: 7,
	    			size: 17,
	    			constraint: 18,
	    			color: 19,
	    			solid: 20,
	    			_content: 1,
	    			_theme: 2,
	    			_lastTheme: 9,
	    			_className: 3,
	    			_style: 4,
	    			_iconElement: 5,
	    			_lastName: 10,
	    			_lastPath: 11,
	    			_lastUrl: 12,
	    			hasValue: 21
	    		});
	    	}

	    	get hasValue() {
	    		return hasValue$3;
	    	}
	    }

	    createCommonjsModule(function (module, exports) {
	    (function (global, factory) {
	      factory(exports) ;
	    }(commonjsGlobal$1, (function (exports) {
	      function _classCallCheck(a, n) {
	        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	      }
	      function _defineProperties(e, r) {
	        for (var t = 0; t < r.length; t++) {
	          var o = r[t];
	          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
	        }
	      }
	      function _createClass(e, r, t) {
	        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	          writable: !1
	        }), e;
	      }
	      function _toPrimitive(t, r) {
	        if ("object" != typeof t || !t) return t;
	        var e = t[Symbol.toPrimitive];
	        if (void 0 !== e) {
	          var i = e.call(t, r || "default");
	          if ("object" != typeof i) return i;
	          throw new TypeError("@@toPrimitive must return a primitive value.");
	        }
	        return ("string" === r ? String : Number)(t);
	      }
	      function _toPropertyKey(t) {
	        var i = _toPrimitive(t, "string");
	        return "symbol" == typeof i ? i : i + "";
	      }

	      function styleInject(css, ref) {
	        if ( ref === void 0 ) ref = {};
	        var insertAt = ref.insertAt;

	        if (!css || typeof document === 'undefined') { return; }

	        var head = document.head || document.getElementsByTagName('head')[0];
	        var style = document.createElement('style');
	        style.type = 'text/css';

	        if (insertAt === 'top') {
	          if (head.firstChild) {
	            head.insertBefore(style, head.firstChild);
	          } else {
	            head.appendChild(style);
	          }
	        } else {
	          head.appendChild(style);
	        }

	        if (style.styleSheet) {
	          style.styleSheet.cssText = css;
	        } else {
	          style.appendChild(document.createTextNode(css));
	        }
	      }

	      var css_248z = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:FormaDJR,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}pros-tooltip-overlay.pros-custom-tooltip{padding:0;overflow:hidden}";
	      styleInject(css_248z);

	      var Tooltips = /*#__PURE__*/function () {
	        function Tooltips() {
	          _classCallCheck(this, Tooltips);
	          this._observers = new WeakMap();
	          this._listeners = {
	            mouseenter: new WeakMap(),
	            mouseleave: new WeakMap()
	          };
	        }
	        return _createClass(Tooltips, [{
	          key: "addObserver",
	          value: function addObserver() {
	            var _this = this;
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            if (this._observers.get(target)) {
	              // Could also throw an error
	              return;
	            }
	            var observer = new MutationObserver(function (mutations) {
	              mutations.forEach(function (mutation) {
	                if (mutation.type !== 'childList') {
	                  return;
	                }
	                var addedNodes = mutation.addedNodes;
	                for (var i = 0; i < addedNodes.length; i++) {
	                  var node = addedNodes[i];
	                  if (!node.querySelectorAll) {
	                    continue;
	                  }

	                  //Check node itself and then children
	                  if (node.hasAttribute('pros-tooltip')) {
	                    _this._bind(node);
	                  }
	                  var elements = node.querySelectorAll('[pros-tooltip]');
	                  if (elements.length > 0) {
	                    for (var j = 0; j < elements.length; j++) {
	                      var element = elements[j];
	                      _this._bind(element);
	                    }
	                  }
	                }
	                var removedNodes = mutation.removedNodes;
	                for (var _i = 0; _i < removedNodes.length; _i++) {
	                  var _node = removedNodes[_i];
	                  if (!_node.querySelectorAll) {
	                    continue;
	                  }
	                  if (_node.hasAttribute('pros-tooltip')) {
	                    _this._unbind(_node);
	                  }
	                  var _elements = _node.querySelectorAll('[pros-tooltip]');
	                  if (_elements.length > 0) {
	                    for (var _j = 0; _j < _elements.length; _j++) {
	                      var _element = _elements[_j];
	                      _this._unbind(_element);
	                    }
	                  }
	                }
	              });
	            });
	            observer.observe(target, {
	              childList: true,
	              subtree: true,
	              attributes: false,
	              characterData: false
	            });
	            this._observers.set(target, observer);
	          }
	        }, {
	          key: "removeObserver",
	          value: function removeObserver() {
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            var observer = this._observers.get(target);
	            if (observer) {
	              observer.disconnect();
	              this._observers["delete"](target);
	            }
	          }
	        }, {
	          key: "hasTooltipContent",
	          value: function hasTooltipContent(value, el) {
	            var attributeValue = el.getAttribute('pros-tooltip');
	            if (attributeValue) {
	              attributeValue = attributeValue.trim();
	            }
	            var elContent = el.textContent.trim();
	            return attributeValue !== '' || elContent !== '';
	          }
	        }, {
	          key: "_bind",
	          value: function _bind(el) {
	            var _this2 = this;
	            var listener = function listener() {
	              var attributeValue = el.getAttribute('pros-tooltip');
	              if (!_this2.hasTooltipContent(attributeValue, el) || !attributeValue && isFullContentVisible(el)) {
	                // not specified and text not truncated - don't show tooltip
	                return;
	              }
	              var tooltipEl = document.createElement('pros-tooltip-overlay');
	              setContent(tooltipEl, el);
	              setPosition(tooltipEl, el);

	              // Hide, then append to get width, then show once width corrected.
	              // Approach from http://stackoverflow.com/a/2930159/277307
	              hideElement(tooltipEl);
	              document.body.appendChild(tooltipEl);
	              ensureEvenWidth(tooltipEl);
	              ensureNotClipped(tooltipEl);
	              showElement(tooltipEl);
	              removeOnMouseLeave.call(_this2, tooltipEl, el);
	            };
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (!enterListener) {
	              el.addEventListener('mouseenter', listener);
	              this._listeners.mouseenter.set(el, listener);
	            }
	          }
	        }, {
	          key: "_unbind",
	          value: function _unbind(el) {
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (enterListener) {
	              el.removeEventListener('mouseenter', enterListener);
	              this._listeners.mouseenter["delete"](el);
	            }
	            var leaveListener = this._listeners.mouseleave.get(el);
	            if (leaveListener) {
	              leaveListener.call(this);
	            }
	          }
	        }]);
	      }(); // Adapted from http://stackoverflow.com/a/10017343/277307
	      function isFullContentVisible(el) {
	        return el.offsetWidth >= el.scrollWidth;
	      }
	      function setPosition(tooltipEl, el) {
	        tooltipEl.style.position = 'fixed';
	        var elRect = el.getBoundingClientRect();
	        tooltipEl.style.top = elRect.top + elRect.height + 'px';
	        // Center horizontally under element
	        tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
	        return tooltipEl;
	      }
	      function setContent(tooltipEl, el) {
	        var attrValue = el.getAttribute('pros-tooltip');
	        if (attrValue) {
	          // Use value if provided
	          if (attrValue[0] === '<') {
	            tooltipEl.innerHTML = attrValue;
	            tooltipEl.style.whiteSpace = 'unset';
	            tooltipEl.classList.add('pros-custom-tooltip');
	          } else {
	            tooltipEl.textContent = attrValue;
	          }
	        } else {
	          // Element text by default
	          tooltipEl.textContent = el.textContent;
	        }
	        return tooltipEl;
	      }
	      function removeOnMouseLeave(tooltipEl, el) {
	        var _this3 = this;
	        var _leaveHandler = function leaveHandler() {
	          document.body.removeChild(tooltipEl);
	          el.removeEventListener('mouseleave', _leaveHandler);
	          _this3._listeners.mouseleave["delete"](el);
	        };
	        el.addEventListener('mouseleave', _leaveHandler);
	        this._listeners.mouseleave.set(el, _leaveHandler);
	      }
	      function hideElement(tooltipEl) {
	        tooltipEl.style.visibility = 'hidden';
	      }
	      function showElement(tooltipEl) {
	        tooltipEl.style.removeProperty('visibility');
	      }

	      // Necessary because of chrome font antialiasing with translations on odd widths
	      // will cause blurry text. See http://stackoverflow.com/a/41456864/277307
	      function ensureEvenWidth(tooltipEl) {
	        var width = Math.round(tooltipEl.getBoundingClientRect().width);
	        if (width % 2 !== 0) {
	          width++;
	          tooltipEl.style.width = width + 'px';
	        }
	      }
	      function ensureNotClipped(tooltipEl) {
	        // Ensure not clipped by window boundary,
	        // since we're transforming left 50% and width could exceed the window.
	        var rect = tooltipEl.getBoundingClientRect();
	        var halfWidth = rect.width / 2;
	        if (rect.left < 0) {
	          tooltipEl.style.left = halfWidth + 'px';
	        } else if (rect.right > window.innerWidth) {
	          tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
	        }
	      }

	      exports.Tooltips = Tooltips;

	      Object.defineProperty(exports, '__esModule', { value: true });

	    })));
	    });

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/button/node_modules/@printos/agnostic-icon/src/Icon.svelte generated by Svelte v3.38.2 */

	    function add_css$2() {
	    	var style = element("style");
	    	style.id = "svelte-1if0avd-style";
	    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	    	append(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$3(ctx) {
	    	let html_tag;
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(/*_content*/ ctx[1], target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    function create_fragment$3(ctx) {
	    	let div1;
	    	let div0;
	    	let div0_pros_tooltip_value;
	    	let div1_class_value;
	    	let if_block = /*_content*/ ctx[1] && create_if_block$3(ctx);

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			if (if_block) if_block.c();
	    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
	    			attr(div0, "style", /*_style*/ ctx[4]);
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
	    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
	    			attr(div1, "style", /*_style*/ ctx[4]);
	    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			if (if_block) if_block.m(div0, null);
	    			/*div1_binding*/ ctx[22](div1);
	    		},
	    		p(ctx, [dirty]) {
	    			if (/*_content*/ ctx[1]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block$3(ctx);
	    					if_block.c();
	    					if_block.m(div0, null);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div0, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
	    				attr(div1, "class", div1_class_value);
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div1, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*_theme*/ 4) {
	    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			}

	    			if (dirty & /*mode*/ 1) {
	    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			}

	    			if (dirty & /*_className, disabled*/ 136) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			if (if_block) if_block.d();
	    			/*div1_binding*/ ctx[22](null);
	    		}
	    	};
	    }

	    function hasValue$2(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$3($$self, $$props, $$invalidate) {
	    	createEventDispatcher();
	    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { mode = "default" } = $$props; // default/form
	    	let { className = "" } = $$props; // Class name
	    	let { tooltip } = $$props;
	    	let { disabled = false } = $$props;
	    	let { size = "24px" } = $$props;
	    	let { constraint = "h" } = $$props;
	    	let { color } = $$props;
	    	let { solid = false } = $$props;
	    	let { _content = undefined } = $$props;
	    	let { _theme } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _className } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _iconElement = undefined } = $$props;
	    	let { _lastName = null } = $$props;
	    	let { _lastPath = null } = $$props;
	    	let { _lastUrl = null } = $$props;

	    	onMount(() => {
	    		$$invalidate(3, _className = hasValue$2(className) ? className : "");
	    		updateContent();
	    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	    	beforeUpdate(() => {
	    		$$invalidate(8, theme = hasValue$2(theme) ? theme : "light");
	    		$$invalidate(0, mode = hasValue$2(mode) ? mode : "icon");

	    		if (theme !== _lastTheme) {
	    			$$invalidate(9, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(2, _theme = theme);
	    			}
	    		}

	    		if (name !== _lastName) {
	    			$$invalidate(10, _lastName = name);
	    			updateContent();
	    		}

	    		if (path !== _lastPath) {
	    			$$invalidate(11, _lastPath = path);
	    			updateContent();
	    		}

	    		if (url !== _lastUrl) {
	    			$$invalidate(12, _lastUrl = url);
	    			updateContent();
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function updateContent() {
	    		if (name) {
	    			let myName = solid ? name : `${name}-o`;
	    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	    		} else if (path) {
	    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	    		} else if (url) {
	    			loadContent.call(this, url);
	    		}
	    	}

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(2, _theme = event.detail.theme);
	    		}
	    	}

	    	// Others
	    	function loadContent(url) {
	    		let config = {
	    			url,
	    			cache: true,
	    			credentials: "omit",
	    			responseType: "text"
	    		};

	    		return dist.http.request(config).then(resp => {
	    			$$invalidate(1, _content = resp.data);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_iconElement = $$value;
	    			$$invalidate(5, _iconElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
	    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
	    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
	    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
	    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
	    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
	    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
	    			// onState
	    			{
	    				if (size) {
	    					let h;
	    					let w;

	    					switch (constraint) {
	    						case "b":
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = isNaN(size) ? size : `${size}px`;
	    							break;
	    						case "w":
	    							w = isNaN(size) ? size : `${size}px`;
	    							h = "fit-content";
	    							break;
	    						case "h":
	    						default:
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = "fit-content";
	    							break;
	    					}

	    					$$invalidate(4, _style = `height:${h};width:${w};`);
	    				}

	    				if (color) {
	    					if (hasValue$2(color)) {
	    						$$invalidate(4, _style += `color:${color};fill:${color}`);
	    					}
	    				}
	    			}
	    		}
	    	};

	    	return [
	    		mode,
	    		_content,
	    		_theme,
	    		_className,
	    		_style,
	    		_iconElement,
	    		tooltip,
	    		disabled,
	    		theme,
	    		_lastTheme,
	    		_lastName,
	    		_lastPath,
	    		_lastUrl,
	    		name,
	    		path,
	    		url,
	    		className,
	    		size,
	    		constraint,
	    		color,
	    		solid,
	    		hasValue$2,
	    		div1_binding
	    	];
	    }

	    class Icon extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1if0avd-style")) add_css$2();

	    		init(this, options, instance$3, create_fragment$3, safe_not_equal, {
	    			name: 13,
	    			path: 14,
	    			url: 15,
	    			theme: 8,
	    			mode: 0,
	    			className: 16,
	    			tooltip: 6,
	    			disabled: 7,
	    			size: 17,
	    			constraint: 18,
	    			color: 19,
	    			solid: 20,
	    			_content: 1,
	    			_theme: 2,
	    			_lastTheme: 9,
	    			_className: 3,
	    			_style: 4,
	    			_iconElement: 5,
	    			_lastName: 10,
	    			_lastPath: 11,
	    			_lastUrl: 12,
	    			hasValue: 21
	    		});
	    	}

	    	get hasValue() {
	    		return hasValue$2;
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/spinner/src/Spinner.svelte generated by Svelte v3.38.2 */

	    function create_else_block$2(ctx) {
	    	let svg;
	    	let rect;
	    	let circle;
	    	let animateTransform;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			rect = svg_element("rect");
	    			circle = svg_element("circle");
	    			animateTransform = svg_element("animateTransform");
	    			attr(rect, "x", "0");
	    			attr(rect, "y", "0");
	    			attr(rect, "width", "100");
	    			attr(rect, "height", "100");
	    			attr(rect, "fill", "none");
	    			attr(rect, "class", "bk");
	    			attr(animateTransform, "attributeName", "transform");
	    			attr(animateTransform, "type", "rotate");
	    			attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
	    			attr(animateTransform, "keyTimes", "0;0.5;1");
	    			attr(animateTransform, "dur", "1s");
	    			attr(animateTransform, "repeatCount", "indefinite");
	    			attr(animateTransform, "begin", "0s");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "50");
	    			attr(circle, "r", "42.5");
	    			attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
	    			attr(circle, "stroke", "currentColor");
	    			attr(circle, "fill", "none");
	    			attr(circle, "stroke-width", "15");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    			attr(svg, "preserveAspectRatio", "xMidYMid");
	    			attr(svg, "class", "uil-ring");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, rect);
	    			append(svg, circle);
	    			append(circle, animateTransform);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    // (2:2) {#if mode === 'printos'}
	    function create_if_block$2(ctx) {
	    	let svg;
	    	let style;
	    	let t;
	    	let path0;
	    	let path1;
	    	let g;
	    	let circle;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			style = svg_element("style");
	    			t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
	    			path0 = svg_element("path");
	    			path1 = svg_element("path");
	    			g = svg_element("g");
	    			circle = svg_element("circle");
	    			attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
	    			attr(path0, "id", "el_OK7WH8ppuY");
	    			attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
	    			attr(path1, "id", "el_pzIR5oVpeo");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "67.33");
	    			attr(circle, "r", "25");
	    			attr(circle, "stroke-dasharray", "55");
	    			attr(circle, "id", "el_3R6WG92ED-");
	    			attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
	    			attr(g, "data-animator-group", "true");
	    			attr(g, "data-animator-type", "1");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "id", "el_ztyBp85wH");
	    			attr(svg, "data-name", "Layer 1");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, style);
	    			append(style, t);
	    			append(svg, path0);
	    			append(svg, path1);
	    			append(svg, g);
	    			append(g, circle);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    function create_fragment$2(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*mode*/ ctx[1] === "printos") return create_if_block$2;
	    		return create_else_block$2;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-spinner");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, [dirty]) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    function instance$2($$self, $$props, $$invalidate) {
	    	let { diameter = null } = $$props;
	    	let { mode = null } = $$props;
	    	let { color = null } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _diameter = null } = $$props;

	    	$$self.$$set = $$props => {
	    		if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
	    		if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
	    		if ("color" in $$props) $$invalidate(4, color = $$props.color);
	    		if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
	    		if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/ 31) {
	    			{
	    				$$invalidate(2, _diameter = diameter ? Number(diameter) : null);

	    				if (!_diameter) {
	    					$$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
	    				}

	    				$$invalidate(0, _style = `height:${_diameter}px;width:${_diameter}px;`);
	    				$$invalidate(0, _style += color ? `color:${color};` : `color:#0096d6;`);
	    			}
	    		}
	    	};

	    	return [_style, mode, _diameter, diameter, color];
	    }

	    class Spinner extends SvelteComponent {
	    	constructor(options) {
	    		super();

	    		init(this, options, instance$2, create_fragment$2, safe_not_equal, {
	    			diameter: 3,
	    			mode: 1,
	    			color: 4,
	    			_style: 0,
	    			_diameter: 2
	    		});
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/button/src/Button.svelte generated by Svelte v3.38.2 */

	    function add_css$1() {
	    	var style = element("style");
	    	style.id = "svelte-192il0a-style";
	    	style.textContent = ".pros-button-wrapper.svelte-192il0a.svelte-192il0a{display:flex;justify-content:center;align-items:center;height:48px;min-width:48px;padding:0 16px 0 16px;user-select:none;border-radius:12px;box-sizing:border-box;cursor:pointer;appearance:none;outline:none;border:0;margin:0;overflow:visible;text-decoration:none;text-transform:none;box-shadow:none;font-size:16px;position:relative;transition:background-color 0.3s ease}.pros-button-wrapper.icon-only.svelte-192il0a.svelte-192il0a{padding:0 16px;width:48px}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:after{border-radius:14px;border-width:2px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper.svelte-192il0a .pros-button-content.svelte-192il0a{display:flex;justify-content:flex-start;align-items:center}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-4px}.pros-button-wrapper.disabled.svelte-192il0a.svelte-192il0a:after{opacity:0;inset:0}.pros-button-wrapper.svelte-192il0a .pros-icon-container.svelte-192il0a{min-width:24px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.left.svelte-192il0a{margin-right:8px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.right.svelte-192il0a{margin-left:8px}.pros-button-wrapper.svelte-192il0a .pros-button-label.svelte-192il0a{flex:1;white-space:nowrap}.pros-button-wrapper[pos--density=high].svelte-192il0a.svelte-192il0a{height:36px;min-width:36px;border-radius:8px}.pros-button-wrapper[pos--density=high].icon-only.svelte-192il0a.svelte-192il0a{width:36px}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a{border-radius:unset}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a:after{border-radius:0}.pros-button-wrapper[pos--mode=form].svelte-192il0a.svelte-192il0a{margin-bottom:20px}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a{height:auto;width:auto;min-width:unset;padding:0}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a{height:32px;min-width:32px;padding:0;border-radius:4px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:focus:after{opacity:0;inset:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a{padding:0;max-height:36px;width:36px;min-width:36px;border-radius:10px}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:after{border-radius:12px;border-width:1px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-2px}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#035c84}.pros-button-wrapper[pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#212121;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#404040;background-color:#ffffff}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#363636}.pros-button-wrapper[pos--theme=light][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#135b08}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#a90b0a}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#b55500}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #027aae;color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #1c7a17;color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #be1313;color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #d06702;color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a{color:#404040;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#6dd0fb}.pros-button-wrapper[pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:#2b2b2b}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#f1f1f1}.pros-button-wrapper[pos--theme=dark][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#8ef291}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#f48787}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#fdd1a5}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #3ab4eb;color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #67df6a;color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #eb5e5e;color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #f9c086;color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}";
	    	append(document.head, style);
	    }

	    // (16:0) {:else}
	    function create_else_block$1(ctx) {
	    	let button;
	    	let div;
	    	let t;
	    	let button_class_value;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*loading*/ ctx[11] && create_if_block_7();
	    	let if_block1 = !/*loading*/ ctx[11] && create_if_block_4(ctx);

	    	return {
	    		c() {
	    			button = element("button");
	    			div = element("div");
	    			if (if_block0) if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			attr(div, "class", "pros-button-content svelte-192il0a");
	    			attr(button, "id", /*_id*/ ctx[21]);
	    			attr(button, "type", "button");
	    			attr(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a");
	    			attr(button, "style", /*_style*/ ctx[18]);
	    			attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			attr(button, "pos--density", /*_density*/ ctx[16]);
	    			attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			attr(button, "pos--display", /*display*/ ctx[8]);
	    			toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    		},
	    		m(target, anchor) {
	    			insert(target, button, anchor);
	    			append(button, div);
	    			if (if_block0) if_block0.m(div, null);
	    			append(div, t);
	    			if (if_block1) if_block1.m(div, null);
	    			/*button_binding_1*/ ctx[57](button);
	    			current = true;

	    			if (!mounted) {
	    				dispose = listen(button, "click", /*handleClick*/ ctx[22]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*loading*/ ctx[11]) {
	    				if (if_block0) {
	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_7();
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(div, t);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!/*loading*/ ctx[11]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_4(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(div, null);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*_id*/ 2097152) {
	    				attr(button, "id", /*_id*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_class*/ 131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a")) {
	    				attr(button, "class", button_class_value);
	    			}

	    			if (!current || dirty[0] & /*_style*/ 262144) {
	    				attr(button, "style", /*_style*/ ctx[18]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 16384) {
	    				attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 32768) {
	    				attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 65536) {
	    				attr(button, "pos--density", /*_density*/ ctx[16]);
	    			}

	    			if (!current || dirty[0] & /*mode*/ 8) {
	    				attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			}

	    			if (!current || dirty[0] & /*scheme*/ 16) {
	    				attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			}

	    			if (!current || dirty[0] & /*display*/ 256) {
	    				attr(button, "pos--display", /*display*/ ctx[8]);
	    			}

	    			if (dirty[0] & /*_class, disabled*/ 132096) {
	    				toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(button);
	    			if (if_block0) if_block0.d();
	    			if (if_block1) if_block1.d();
	    			/*button_binding_1*/ ctx[57](null);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (1:0) {#if _iconOnly}
	    function create_if_block$1(ctx) {
	    	let button;
	    	let div;
	    	let t;
	    	let button_class_value;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*loading*/ ctx[11] && create_if_block_3$1();
	    	let if_block1 = !/*loading*/ ctx[11] && create_if_block_1$1(ctx);

	    	return {
	    		c() {
	    			button = element("button");
	    			div = element("div");
	    			if (if_block0) if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			attr(div, "class", "pros-button-content svelte-192il0a");
	    			attr(button, "id", /*_id*/ ctx[21]);
	    			attr(button, "type", "button");
	    			attr(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a");
	    			attr(button, "style", /*_style*/ ctx[18]);
	    			attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			attr(button, "pos--density", /*_density*/ ctx[16]);
	    			attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			attr(button, "pos--display", /*display*/ ctx[8]);
	    			attr(button, "pros-tooltip", /*label*/ ctx[9]);
	    			toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			toggle_class(button, "icon-only", /*_iconOnly*/ ctx[12]);
	    		},
	    		m(target, anchor) {
	    			insert(target, button, anchor);
	    			append(button, div);
	    			if (if_block0) if_block0.m(div, null);
	    			append(div, t);
	    			if (if_block1) if_block1.m(div, null);
	    			/*button_binding*/ ctx[42](button);
	    			current = true;

	    			if (!mounted) {
	    				dispose = listen(button, "click", /*handleClick*/ ctx[22]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*loading*/ ctx[11]) {
	    				if (if_block0) {
	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_3$1();
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(div, t);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!/*loading*/ ctx[11]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_1$1(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(div, null);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*_id*/ 2097152) {
	    				attr(button, "id", /*_id*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_class*/ 131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a")) {
	    				attr(button, "class", button_class_value);
	    			}

	    			if (!current || dirty[0] & /*_style*/ 262144) {
	    				attr(button, "style", /*_style*/ ctx[18]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 16384) {
	    				attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 32768) {
	    				attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 65536) {
	    				attr(button, "pos--density", /*_density*/ ctx[16]);
	    			}

	    			if (!current || dirty[0] & /*mode*/ 8) {
	    				attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			}

	    			if (!current || dirty[0] & /*scheme*/ 16) {
	    				attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			}

	    			if (!current || dirty[0] & /*display*/ 256) {
	    				attr(button, "pos--display", /*display*/ ctx[8]);
	    			}

	    			if (!current || dirty[0] & /*label*/ 512) {
	    				attr(button, "pros-tooltip", /*label*/ ctx[9]);
	    			}

	    			if (dirty[0] & /*_class, disabled*/ 132096) {
	    				toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*_class, _iconOnly*/ 135168) {
	    				toggle_class(button, "icon-only", /*_iconOnly*/ ctx[12]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(button);
	    			if (if_block0) if_block0.d();
	    			if (if_block1) if_block1.d();
	    			/*button_binding*/ ctx[42](null);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (19:4) {#if loading}
	    function create_if_block_7(ctx) {
	    	let spinner;
	    	let current;
	    	spinner = new Spinner({ props: { diameter: "24" } });

	    	return {
	    		c() {
	    			create_component(spinner.$$.fragment);
	    		},
	    		m(target, anchor) {
	    			mount_component(spinner, target, anchor);
	    			current = true;
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(spinner.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(spinner.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			destroy_component(spinner, detaching);
	    		}
	    	};
	    }

	    // (22:4) {#if !loading}
	    function create_if_block_4(ctx) {
	    	let t0;
	    	let div;
	    	let t1;
	    	let t2;
	    	let if_block1_anchor;
	    	let current;
	    	let if_block0 = /*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "left" && create_if_block_6(ctx);
	    	let if_block1 = /*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "right" && create_if_block_5(ctx);

	    	return {
	    		c() {
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div = element("div");
	    			t1 = text(/*label*/ ctx[9]);
	    			t2 = space();
	    			if (if_block1) if_block1.c();
	    			if_block1_anchor = empty();
	    			attr(div, "class", "pros-button-label svelte-192il0a");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "right", /*iconPosition*/ ctx[5] === "right");
	    		},
	    		m(target, anchor) {
	    			if (if_block0) if_block0.m(target, anchor);
	    			insert(target, t0, anchor);
	    			insert(target, div, anchor);
	    			append(div, t1);
	    			insert(target, t2, anchor);
	    			if (if_block1) if_block1.m(target, anchor);
	    			insert(target, if_block1_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "left") {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon, iconPosition*/ 8224) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_6(ctx);
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(t0.parentNode, t0);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*label*/ 512) set_data(t1, /*label*/ ctx[9]);

	    			if (dirty[0] & /*iconPosition*/ 32) {
	    				toggle_class(div, "right", /*iconPosition*/ ctx[5] === "right");
	    			}

	    			if (/*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "right") {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon, iconPosition*/ 8224) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_5(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (if_block0) if_block0.d(detaching);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div);
	    			if (detaching) detach(t2);
	    			if (if_block1) if_block1.d(detaching);
	    			if (detaching) detach(if_block1_anchor);
	    		}
	    	};
	    }

	    // (23:6) {#if _hasIcon && iconPosition === 'left'}
	    function create_if_block_6(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding_1(value) {
	    		/*icon_1_name_binding_1*/ ctx[43](value);
	    	}

	    	function icon_1_path_binding_1(value) {
	    		/*icon_1_path_binding_1*/ ctx[44](value);
	    	}

	    	function icon_1_url_binding_1(value) {
	    		/*icon_1_url_binding_1*/ ctx[45](value);
	    	}

	    	function icon_1_solid_binding_1(value) {
	    		/*icon_1_solid_binding_1*/ ctx[46](value);
	    	}

	    	function icon_1_size_binding_1(value) {
	    		/*icon_1_size_binding_1*/ ctx[47](value);
	    	}

	    	function icon_1_constraint_binding_1(value) {
	    		/*icon_1_constraint_binding_1*/ ctx[48](value);
	    	}

	    	function icon_1_theme_binding_1(value) {
	    		/*icon_1_theme_binding_1*/ ctx[49](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding_1));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container left svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    // (29:6) {#if _hasIcon && iconPosition === 'right'}
	    function create_if_block_5(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding_2(value) {
	    		/*icon_1_name_binding_2*/ ctx[50](value);
	    	}

	    	function icon_1_path_binding_2(value) {
	    		/*icon_1_path_binding_2*/ ctx[51](value);
	    	}

	    	function icon_1_url_binding_2(value) {
	    		/*icon_1_url_binding_2*/ ctx[52](value);
	    	}

	    	function icon_1_solid_binding_2(value) {
	    		/*icon_1_solid_binding_2*/ ctx[53](value);
	    	}

	    	function icon_1_size_binding_2(value) {
	    		/*icon_1_size_binding_2*/ ctx[54](value);
	    	}

	    	function icon_1_constraint_binding_2(value) {
	    		/*icon_1_constraint_binding_2*/ ctx[55](value);
	    	}

	    	function icon_1_theme_binding_2(value) {
	    		/*icon_1_theme_binding_2*/ ctx[56](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding_2));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container right svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    // (4:4) {#if loading}
	    function create_if_block_3$1(ctx) {
	    	let spinner;
	    	let current;
	    	spinner = new Spinner({ props: { diameter: "24" } });

	    	return {
	    		c() {
	    			create_component(spinner.$$.fragment);
	    		},
	    		m(target, anchor) {
	    			mount_component(spinner, target, anchor);
	    			current = true;
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(spinner.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(spinner.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			destroy_component(spinner, detaching);
	    		}
	    	};
	    }

	    // (7:4) {#if !loading}
	    function create_if_block_1$1(ctx) {
	    	let if_block_anchor;
	    	let current;
	    	let if_block = /*_hasIcon*/ ctx[13] && create_if_block_2$1(ctx);

	    	return {
	    		c() {
	    			if (if_block) if_block.c();
	    			if_block_anchor = empty();
	    		},
	    		m(target, anchor) {
	    			if (if_block) if_block.m(target, anchor);
	    			insert(target, if_block_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasIcon*/ ctx[13]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon*/ 8192) {
	    						transition_in(if_block, 1);
	    					}
	    				} else {
	    					if_block = create_if_block_2$1(ctx);
	    					if_block.c();
	    					transition_in(if_block, 1);
	    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
	    				}
	    			} else if (if_block) {
	    				group_outros();

	    				transition_out(if_block, 1, 1, () => {
	    					if_block = null;
	    				});

	    				check_outros();
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (if_block) if_block.d(detaching);
	    			if (detaching) detach(if_block_anchor);
	    		}
	    	};
	    }

	    // (8:6) {#if _hasIcon}
	    function create_if_block_2$1(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding(value) {
	    		/*icon_1_name_binding*/ ctx[35](value);
	    	}

	    	function icon_1_path_binding(value) {
	    		/*icon_1_path_binding*/ ctx[36](value);
	    	}

	    	function icon_1_url_binding(value) {
	    		/*icon_1_url_binding*/ ctx[37](value);
	    	}

	    	function icon_1_solid_binding(value) {
	    		/*icon_1_solid_binding*/ ctx[38](value);
	    	}

	    	function icon_1_size_binding(value) {
	    		/*icon_1_size_binding*/ ctx[39](value);
	    	}

	    	function icon_1_constraint_binding(value) {
	    		/*icon_1_constraint_binding*/ ctx[40](value);
	    	}

	    	function icon_1_theme_binding(value) {
	    		/*icon_1_theme_binding*/ ctx[41](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    function create_fragment$1(ctx) {
	    	let current_block_type_index;
	    	let if_block;
	    	let if_block_anchor;
	    	let current;
	    	const if_block_creators = [create_if_block$1, create_else_block$1];
	    	const if_blocks = [];

	    	function select_block_type(ctx, dirty) {
	    		if (/*_iconOnly*/ ctx[12]) return 0;
	    		return 1;
	    	}

	    	current_block_type_index = select_block_type(ctx);
	    	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	    	return {
	    		c() {
	    			if_block.c();
	    			if_block_anchor = empty();
	    		},
	    		m(target, anchor) {
	    			if_blocks[current_block_type_index].m(target, anchor);
	    			insert(target, if_block_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			let previous_block_index = current_block_type_index;
	    			current_block_type_index = select_block_type(ctx);

	    			if (current_block_type_index === previous_block_index) {
	    				if_blocks[current_block_type_index].p(ctx, dirty);
	    			} else {
	    				group_outros();

	    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
	    					if_blocks[previous_block_index] = null;
	    				});

	    				check_outros();
	    				if_block = if_blocks[current_block_type_index];

	    				if (!if_block) {
	    					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	    					if_block.c();
	    				} else {
	    					if_block.p(ctx, dirty);
	    				}

	    				transition_in(if_block, 1);
	    				if_block.m(if_block_anchor.parentNode, if_block_anchor);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if_blocks[current_block_type_index].d(detaching);
	    			if (detaching) detach(if_block_anchor);
	    		}
	    	};
	    }

	    function hasValue$1(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$1($$self, $$props, $$invalidate) {
	    	const dispatch = createEventDispatcher();
	    	let { mode = "default" } = $$props; // Icon, Button, Toolbar_Icon, Toolbar_Button
	    	let { display = "primary" } = $$props; // primary, secondary, ghost, panel
	    	let { theme = "light" } = $$props; // auto, light, dark
	    	let { shape = "round" } = $$props; // round/sharp
	    	let { density = "standard" } = $$props; // standard/high
	    	let { scheme = "default" } = $$props; // default/positive/negative/warning
	    	let { iconName = "" } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { iconPath = "" } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { iconUrl = "" } = $$props; // Full path of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { iconPosition = "left" } = $$props; // Icon to left or right of text
	    	let { iconSize = "24px" } = $$props; // Icon to left or right of text
	    	let { iconConstraint = "h" } = $$props; // Icon to left or right of text
	    	let { icon = false } = $$props; // Icon to left or right of text
	    	let { label = "" } = $$props; // Button name or Tooltip for Icon Button
	    	let { className = "" } = $$props; // Class name
	    	let { disabled = false } = $$props;
	    	let { solid = false } = $$props;
	    	let { height } = $$props;
	    	let { width } = $$props;
	    	let { loading = false } = $$props;
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _hasIcon = false;

	    	let _iconOnly = false;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _class;
	    	let _style = "";
	    	let _solid = false;
	    	let _buttonWrapper;
	    	let _width;
	    	let _height;
	    	let _id;

	    	onMount(() => {
	    		
	    	}); // _buttonWrapper.parentElement.style.height = _height;

	    	beforeUpdate(() => {
	    		$$invalidate(23, theme = hasValue$1(theme) ? theme : "light");
	    		$$invalidate(3, mode = hasValue$1(mode) ? mode : "default");
	    		$$invalidate(4, scheme = hasValue$1(scheme) ? scheme : "default");

	    		$$invalidate(19, _solid = hasValue$1(solid)
	    		? solid === true || solid === "true"
	    		: false);

	    		$$invalidate(17, _class = hasValue$1(className) ? className : "");
	    		$$invalidate(5, iconPosition = hasValue$1(iconPosition) ? iconPosition : "left");
	    		$$invalidate(21, _id = hasValue$1(id) ? `${id}-click` : undefined);

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(14, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(14, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(15, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(15, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(15, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(16, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(16, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(16, _density = density);
	    			}
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(14, _theme = event.detail.theme);
	    		}
	    	}

	    	function handleClick(event) {
	    		if (disabled) {
	    			event.stopPropagation();
	    			return;
	    		}

	    		_buttonWrapper.blur();

	    		window.setTimeout(() => {
	    			dispatch("clicked", event);
	    		});
	    	}

	    	function icon_1_name_binding(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function button_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_buttonWrapper = $$value;
	    			$$invalidate(20, _buttonWrapper);
	    		});
	    	}

	    	function icon_1_name_binding_1(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding_1(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding_1(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding_1(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding_1(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding_1(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding_1(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function icon_1_name_binding_2(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding_2(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding_2(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding_2(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding_2(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding_2(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding_2(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function button_binding_1($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_buttonWrapper = $$value;
	    			$$invalidate(20, _buttonWrapper);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("mode" in $$props) $$invalidate(3, mode = $$props.mode);
	    		if ("display" in $$props) $$invalidate(8, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(23, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(24, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(25, density = $$props.density);
	    		if ("scheme" in $$props) $$invalidate(4, scheme = $$props.scheme);
	    		if ("iconName" in $$props) $$invalidate(0, iconName = $$props.iconName);
	    		if ("iconPath" in $$props) $$invalidate(1, iconPath = $$props.iconPath);
	    		if ("iconUrl" in $$props) $$invalidate(2, iconUrl = $$props.iconUrl);
	    		if ("iconPosition" in $$props) $$invalidate(5, iconPosition = $$props.iconPosition);
	    		if ("iconSize" in $$props) $$invalidate(6, iconSize = $$props.iconSize);
	    		if ("iconConstraint" in $$props) $$invalidate(7, iconConstraint = $$props.iconConstraint);
	    		if ("icon" in $$props) $$invalidate(26, icon = $$props.icon);
	    		if ("label" in $$props) $$invalidate(9, label = $$props.label);
	    		if ("className" in $$props) $$invalidate(27, className = $$props.className);
	    		if ("disabled" in $$props) $$invalidate(10, disabled = $$props.disabled);
	    		if ("solid" in $$props) $$invalidate(28, solid = $$props.solid);
	    		if ("height" in $$props) $$invalidate(29, height = $$props.height);
	    		if ("width" in $$props) $$invalidate(30, width = $$props.width);
	    		if ("loading" in $$props) $$invalidate(11, loading = $$props.loading);
	    		if ("id" in $$props) $$invalidate(31, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*iconName, iconPath, iconUrl, _iconOnly, width, height, _style, icon*/ 1677987847 | $$self.$$.dirty[1] & /*_width, _height*/ 12) {
	    			// onState
	    			{
	    				if (iconName || iconPath || iconUrl) {
	    					$$invalidate(13, _hasIcon = true);
	    				}

	    				$$invalidate(18, _style = "");
	    				const dw = _iconOnly ? null : "auto";
	    				$$invalidate(33, _width = hasValue$1(width) ? width : dw);

	    				if (_width) {
	    					$$invalidate(33, _width = isNaN(_width) ? _width : `${_width}px`);
	    				} // _buttonWrapper.parentElement.style.minWidth = _width;

	    				$$invalidate(34, _height = hasValue$1(height) ? height : null);

	    				if (_height) {
	    					$$invalidate(34, _height = isNaN(_height) ? _height : `${_height}px`);
	    				}

	    				if (_width) {
	    					$$invalidate(18, _style += `min-width:${_width};`);
	    				}

	    				if (_height) {
	    					$$invalidate(18, _style += `height:${_height};`);
	    				}

	    				$$invalidate(12, _iconOnly = hasValue$1(icon) ? icon : false);
	    			}
	    		}
	    	};

	    	return [
	    		iconName,
	    		iconPath,
	    		iconUrl,
	    		mode,
	    		scheme,
	    		iconPosition,
	    		iconSize,
	    		iconConstraint,
	    		display,
	    		label,
	    		disabled,
	    		loading,
	    		_iconOnly,
	    		_hasIcon,
	    		_theme,
	    		_shape,
	    		_density,
	    		_class,
	    		_style,
	    		_solid,
	    		_buttonWrapper,
	    		_id,
	    		handleClick,
	    		theme,
	    		shape,
	    		density,
	    		icon,
	    		className,
	    		solid,
	    		height,
	    		width,
	    		id,
	    		hasValue$1,
	    		_width,
	    		_height,
	    		icon_1_name_binding,
	    		icon_1_path_binding,
	    		icon_1_url_binding,
	    		icon_1_solid_binding,
	    		icon_1_size_binding,
	    		icon_1_constraint_binding,
	    		icon_1_theme_binding,
	    		button_binding,
	    		icon_1_name_binding_1,
	    		icon_1_path_binding_1,
	    		icon_1_url_binding_1,
	    		icon_1_solid_binding_1,
	    		icon_1_size_binding_1,
	    		icon_1_constraint_binding_1,
	    		icon_1_theme_binding_1,
	    		icon_1_name_binding_2,
	    		icon_1_path_binding_2,
	    		icon_1_url_binding_2,
	    		icon_1_solid_binding_2,
	    		icon_1_size_binding_2,
	    		icon_1_constraint_binding_2,
	    		icon_1_theme_binding_2,
	    		button_binding_1
	    	];
	    }

	    class Button extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-192il0a-style")) add_css$1();

	    		init(
	    			this,
	    			options,
	    			instance$1,
	    			create_fragment$1,
	    			safe_not_equal,
	    			{
	    				mode: 3,
	    				display: 8,
	    				theme: 23,
	    				shape: 24,
	    				density: 25,
	    				scheme: 4,
	    				iconName: 0,
	    				iconPath: 1,
	    				iconUrl: 2,
	    				iconPosition: 5,
	    				iconSize: 6,
	    				iconConstraint: 7,
	    				icon: 26,
	    				label: 9,
	    				className: 27,
	    				disabled: 10,
	    				solid: 28,
	    				height: 29,
	    				width: 30,
	    				loading: 11,
	    				id: 31,
	    				hasValue: 32
	    			},
	    			[-1, -1, -1]
	    		);
	    	}

	    	get hasValue() {
	    		return hasValue$1;
	    	}
	    }

	    const subscriber_queue = [];
	    /**
	     * Creates a `Readable` store that allows reading by subscription.
	     * @param value initial value
	     * @param {StartStopNotifier}start start and stop notifications for subscriptions
	     */
	    function readable(value, start) {
	        return {
	            subscribe: writable(value, start).subscribe
	        };
	    }
	    /**
	     * Create a `Writable` store that allows both updating and reading by subscription.
	     * @param {*=}value initial value
	     * @param {StartStopNotifier=}start start and stop notifications for subscriptions
	     */
	    function writable(value, start = noop) {
	        let stop;
	        const subscribers = [];
	        function set(new_value) {
	            if (safe_not_equal(value, new_value)) {
	                value = new_value;
	                if (stop) { // store is ready
	                    const run_queue = !subscriber_queue.length;
	                    for (let i = 0; i < subscribers.length; i += 1) {
	                        const s = subscribers[i];
	                        s[1]();
	                        subscriber_queue.push(s, value);
	                    }
	                    if (run_queue) {
	                        for (let i = 0; i < subscriber_queue.length; i += 2) {
	                            subscriber_queue[i][0](subscriber_queue[i + 1]);
	                        }
	                        subscriber_queue.length = 0;
	                    }
	                }
	            }
	        }
	        function update(fn) {
	            set(fn(value));
	        }
	        function subscribe(run, invalidate = noop) {
	            const subscriber = [run, invalidate];
	            subscribers.push(subscriber);
	            if (subscribers.length === 1) {
	                stop = start(set) || noop;
	            }
	            run(value);
	            return () => {
	                const index = subscribers.indexOf(subscriber);
	                if (index !== -1) {
	                    subscribers.splice(index, 1);
	                }
	                if (subscribers.length === 0) {
	                    stop();
	                    stop = null;
	                }
	            };
	        }
	        return { set, update, subscribe };
	    }
	    function derived(stores, fn, initial_value) {
	        const single = !Array.isArray(stores);
	        const stores_array = single
	            ? [stores]
	            : stores;
	        const auto = fn.length < 2;
	        return readable(initial_value, (set) => {
	            let inited = false;
	            const values = [];
	            let pending = 0;
	            let cleanup = noop;
	            const sync = () => {
	                if (pending) {
	                    return;
	                }
	                cleanup();
	                const result = fn(single ? values[0] : values, set);
	                if (auto) {
	                    set(result);
	                }
	                else {
	                    cleanup = is_function(result) ? result : noop;
	                }
	            };
	            const unsubscribers = stores_array.map((store, i) => subscribe(store, (value) => {
	                values[i] = value;
	                pending &= ~(1 << i);
	                if (inited) {
	                    sync();
	                }
	            }, () => {
	                pending |= (1 << i);
	            }));
	            inited = true;
	            sync();
	            return function stop() {
	                run_all(unsubscribers);
	                cleanup();
	            };
	        });
	    }

	    var isMergeableObject = function isMergeableObject(value) {
	    	return isNonNullObject(value)
	    		&& !isSpecial(value)
	    };

	    function isNonNullObject(value) {
	    	return !!value && typeof value === 'object'
	    }

	    function isSpecial(value) {
	    	var stringValue = Object.prototype.toString.call(value);

	    	return stringValue === '[object RegExp]'
	    		|| stringValue === '[object Date]'
	    		|| isReactElement(value)
	    }

	    // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	    var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	    function isReactElement(value) {
	    	return value.$$typeof === REACT_ELEMENT_TYPE
	    }

	    function emptyTarget(val) {
	    	return Array.isArray(val) ? [] : {}
	    }

	    function cloneUnlessOtherwiseSpecified(value, options) {
	    	return (options.clone !== false && options.isMergeableObject(value))
	    		? deepmerge(emptyTarget(value), value, options)
	    		: value
	    }

	    function defaultArrayMerge(target, source, options) {
	    	return target.concat(source).map(function(element) {
	    		return cloneUnlessOtherwiseSpecified(element, options)
	    	})
	    }

	    function getMergeFunction(key, options) {
	    	if (!options.customMerge) {
	    		return deepmerge
	    	}
	    	var customMerge = options.customMerge(key);
	    	return typeof customMerge === 'function' ? customMerge : deepmerge
	    }

	    function getEnumerableOwnPropertySymbols(target) {
	    	return Object.getOwnPropertySymbols
	    		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
	    			return Object.propertyIsEnumerable.call(target, symbol)
	    		})
	    		: []
	    }

	    function getKeys(target) {
	    	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	    }

	    function propertyIsOnObject(object, property) {
	    	try {
	    		return property in object
	    	} catch(_) {
	    		return false
	    	}
	    }

	    // Protects from prototype poisoning and unexpected merging up the prototype chain.
	    function propertyIsUnsafe(target, key) {
	    	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
	    		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
	    			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	    }

	    function mergeObject(target, source, options) {
	    	var destination = {};
	    	if (options.isMergeableObject(target)) {
	    		getKeys(target).forEach(function(key) {
	    			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
	    		});
	    	}
	    	getKeys(source).forEach(function(key) {
	    		if (propertyIsUnsafe(target, key)) {
	    			return
	    		}

	    		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
	    			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
	    		} else {
	    			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
	    		}
	    	});
	    	return destination
	    }

	    function deepmerge(target, source, options) {
	    	options = options || {};
	    	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	    	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	    	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	    	// implementations can use it. The caller may not replace it.
	    	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	    	var sourceIsArray = Array.isArray(source);
	    	var targetIsArray = Array.isArray(target);
	    	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	    	if (!sourceAndTargetTypesMatch) {
	    		return cloneUnlessOtherwiseSpecified(source, options)
	    	} else if (sourceIsArray) {
	    		return options.arrayMerge(target, source, options)
	    	} else {
	    		return mergeObject(target, source, options)
	    	}
	    }

	    deepmerge.all = function deepmergeAll(array, options) {
	    	if (!Array.isArray(array)) {
	    		throw new Error('first argument should be an array')
	    	}

	    	return array.reduce(function(prev, next) {
	    		return deepmerge(prev, next, options)
	    	}, {})
	    };

	    var deepmerge_1 = deepmerge;

	    var cjs = deepmerge_1;

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };

	    function __extends(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };

	    function __spreadArray(to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    }

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    var ErrorKind;
	    (function (ErrorKind) {
	        /** Argument is unclosed (e.g. `{0`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
	        /** Argument is empty (e.g. `{}`). */
	        ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
	        /** Argument is malformed (e.g. `{foo!}``) */
	        ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
	        /** Expect an argument type (e.g. `{foo,}`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
	        /** Unsupported argument type (e.g. `{foo,foo}`) */
	        ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
	        /** Expect an argument style (e.g. `{foo, number, }`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
	        /** The number skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
	        /** The date time skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
	        /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
	        /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
	        /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
	        ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
	        /** Missing select argument options (e.g. `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
	        /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
	        /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
	        /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
	        /**
	         * Expecting a message fragment after the `plural` or `selectordinal` selector
	         * (e.g. `{foo, plural, one}`)
	         */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
	        /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
	        /**
	         * Duplicate selectors in `plural` or `selectordinal` argument.
	         * (e.g. {foo, plural, one {#} one {#}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
	        /** Duplicate selectors in `select` argument.
	         * (e.g. {foo, select, apple {apple} apple {apple}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
	        /** Plural or select argument option must have `other` clause. */
	        ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
	        /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
	        ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
	        /** The tag name is invalid. (e.g. `<123>foo</123>`) */
	        ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
	        /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
	        ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
	        /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
	        ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
	    })(ErrorKind || (ErrorKind = {}));

	    var TYPE;
	    (function (TYPE) {
	        /**
	         * Raw text
	         */
	        TYPE[TYPE["literal"] = 0] = "literal";
	        /**
	         * Variable w/o any format, e.g `var` in `this is a {var}`
	         */
	        TYPE[TYPE["argument"] = 1] = "argument";
	        /**
	         * Variable w/ number format
	         */
	        TYPE[TYPE["number"] = 2] = "number";
	        /**
	         * Variable w/ date format
	         */
	        TYPE[TYPE["date"] = 3] = "date";
	        /**
	         * Variable w/ time format
	         */
	        TYPE[TYPE["time"] = 4] = "time";
	        /**
	         * Variable w/ select format
	         */
	        TYPE[TYPE["select"] = 5] = "select";
	        /**
	         * Variable w/ plural format
	         */
	        TYPE[TYPE["plural"] = 6] = "plural";
	        /**
	         * Only possible within plural argument.
	         * This is the `#` symbol that will be substituted with the count.
	         */
	        TYPE[TYPE["pound"] = 7] = "pound";
	        /**
	         * XML-like tag
	         */
	        TYPE[TYPE["tag"] = 8] = "tag";
	    })(TYPE || (TYPE = {}));
	    var SKELETON_TYPE;
	    (function (SKELETON_TYPE) {
	        SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
	        SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
	    })(SKELETON_TYPE || (SKELETON_TYPE = {}));
	    /**
	     * Type Guards
	     */
	    function isLiteralElement(el) {
	        return el.type === TYPE.literal;
	    }
	    function isArgumentElement(el) {
	        return el.type === TYPE.argument;
	    }
	    function isNumberElement(el) {
	        return el.type === TYPE.number;
	    }
	    function isDateElement(el) {
	        return el.type === TYPE.date;
	    }
	    function isTimeElement(el) {
	        return el.type === TYPE.time;
	    }
	    function isSelectElement(el) {
	        return el.type === TYPE.select;
	    }
	    function isPluralElement(el) {
	        return el.type === TYPE.plural;
	    }
	    function isPoundElement(el) {
	        return el.type === TYPE.pound;
	    }
	    function isTagElement(el) {
	        return el.type === TYPE.tag;
	    }
	    function isNumberSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
	    }
	    function isDateTimeSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
	    }

	    // @generated from regex-gen.ts
	    var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

	    /**
	     * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	     * with some tweaks
	     */
	    var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	    /**
	     * Parse Date time skeleton into Intl.DateTimeFormatOptions
	     * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * @public
	     * @param skeleton skeleton string
	     */
	    function parseDateTimeSkeleton(skeleton) {
	        var result = {};
	        skeleton.replace(DATE_TIME_REGEX, function (match) {
	            var len = match.length;
	            switch (match[0]) {
	                // Era
	                case 'G':
	                    result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                    break;
	                // Year
	                case 'y':
	                    result.year = len === 2 ? '2-digit' : 'numeric';
	                    break;
	                case 'Y':
	                case 'u':
	                case 'U':
	                case 'r':
	                    throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	                // Quarter
	                case 'q':
	                case 'Q':
	                    throw new RangeError('`q/Q` (quarter) patterns are not supported');
	                // Month
	                case 'M':
	                case 'L':
	                    result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                    break;
	                // Week
	                case 'w':
	                case 'W':
	                    throw new RangeError('`w/W` (week) patterns are not supported');
	                case 'd':
	                    result.day = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'D':
	                case 'F':
	                case 'g':
	                    throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	                // Weekday
	                case 'E':
	                    result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                    break;
	                case 'e':
	                    if (len < 4) {
	                        throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                case 'c':
	                    if (len < 4) {
	                        throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                // Period
	                case 'a': // AM, PM
	                    result.hour12 = true;
	                    break;
	                case 'b': // am, pm, noon, midnight
	                case 'B': // flexible day periods
	                    throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	                // Hour
	                case 'h':
	                    result.hourCycle = 'h12';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'H':
	                    result.hourCycle = 'h23';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'K':
	                    result.hourCycle = 'h11';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'k':
	                    result.hourCycle = 'h24';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'j':
	                case 'J':
	                case 'C':
	                    throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	                // Minute
	                case 'm':
	                    result.minute = ['numeric', '2-digit'][len - 1];
	                    break;
	                // Second
	                case 's':
	                    result.second = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'S':
	                case 'A':
	                    throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
	                // Zone
	                case 'z': // 1..3, 4: specific non-location format
	                    result.timeZoneName = len < 4 ? 'short' : 'long';
	                    break;
	                case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	                case 'O': // 1, 4: miliseconds in day short, long
	                case 'v': // 1, 4: generic non-location format
	                case 'V': // 1, 2, 3, 4: time zone ID or city
	                case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	                case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                    throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
	            }
	            return '';
	        });
	        return result;
	    }

	    // @generated from regex-gen.ts
	    var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

	    function parseNumberSkeletonFromString(skeleton) {
	        if (skeleton.length === 0) {
	            throw new Error('Number skeleton cannot be empty');
	        }
	        // Parse the skeleton
	        var stringTokens = skeleton
	            .split(WHITE_SPACE_REGEX)
	            .filter(function (x) { return x.length > 0; });
	        var tokens = [];
	        for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
	            var stringToken = stringTokens_1[_i];
	            var stemAndOptions = stringToken.split('/');
	            if (stemAndOptions.length === 0) {
	                throw new Error('Invalid number skeleton');
	            }
	            var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
	            for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
	                var option = options_1[_a];
	                if (option.length === 0) {
	                    throw new Error('Invalid number skeleton');
	                }
	            }
	            tokens.push({ stem: stem, options: options });
	        }
	        return tokens;
	    }
	    function icuUnitToEcma(unit) {
	        return unit.replace(/^(.*?)-/, '');
	    }
	    var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
	    var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
	    var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
	    var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
	    function parseSignificantPrecision(str) {
	        var result = {};
	        if (str[str.length - 1] === 'r') {
	            result.roundingPriority = 'morePrecision';
	        }
	        else if (str[str.length - 1] === 's') {
	            result.roundingPriority = 'lessPrecision';
	        }
	        str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	            // @@@ case
	            if (typeof g2 !== 'string') {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits = g1.length;
	            }
	            // @@@+ case
	            else if (g2 === '+') {
	                result.minimumSignificantDigits = g1.length;
	            }
	            // .### case
	            else if (g1[0] === '#') {
	                result.maximumSignificantDigits = g1.length;
	            }
	            // .@@## or .@@@ case
	            else {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits =
	                    g1.length + (typeof g2 === 'string' ? g2.length : 0);
	            }
	            return '';
	        });
	        return result;
	    }
	    function parseSign(str) {
	        switch (str) {
	            case 'sign-auto':
	                return {
	                    signDisplay: 'auto',
	                };
	            case 'sign-accounting':
	            case '()':
	                return {
	                    currencySign: 'accounting',
	                };
	            case 'sign-always':
	            case '+!':
	                return {
	                    signDisplay: 'always',
	                };
	            case 'sign-accounting-always':
	            case '()!':
	                return {
	                    signDisplay: 'always',
	                    currencySign: 'accounting',
	                };
	            case 'sign-except-zero':
	            case '+?':
	                return {
	                    signDisplay: 'exceptZero',
	                };
	            case 'sign-accounting-except-zero':
	            case '()?':
	                return {
	                    signDisplay: 'exceptZero',
	                    currencySign: 'accounting',
	                };
	            case 'sign-never':
	            case '+_':
	                return {
	                    signDisplay: 'never',
	                };
	        }
	    }
	    function parseConciseScientificAndEngineeringStem(stem) {
	        // Engineering
	        var result;
	        if (stem[0] === 'E' && stem[1] === 'E') {
	            result = {
	                notation: 'engineering',
	            };
	            stem = stem.slice(2);
	        }
	        else if (stem[0] === 'E') {
	            result = {
	                notation: 'scientific',
	            };
	            stem = stem.slice(1);
	        }
	        if (result) {
	            var signDisplay = stem.slice(0, 2);
	            if (signDisplay === '+!') {
	                result.signDisplay = 'always';
	                stem = stem.slice(2);
	            }
	            else if (signDisplay === '+?') {
	                result.signDisplay = 'exceptZero';
	                stem = stem.slice(2);
	            }
	            if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
	                throw new Error('Malformed concise eng/scientific notation');
	            }
	            result.minimumIntegerDigits = stem.length;
	        }
	        return result;
	    }
	    function parseNotationOptions(opt) {
	        var result = {};
	        var signOpts = parseSign(opt);
	        if (signOpts) {
	            return signOpts;
	        }
	        return result;
	    }
	    /**
	     * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	     */
	    function parseNumberSkeleton(tokens) {
	        var result = {};
	        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	            var token = tokens_1[_i];
	            switch (token.stem) {
	                case 'percent':
	                case '%':
	                    result.style = 'percent';
	                    continue;
	                case '%x100':
	                    result.style = 'percent';
	                    result.scale = 100;
	                    continue;
	                case 'currency':
	                    result.style = 'currency';
	                    result.currency = token.options[0];
	                    continue;
	                case 'group-off':
	                case ',_':
	                    result.useGrouping = false;
	                    continue;
	                case 'precision-integer':
	                case '.':
	                    result.maximumFractionDigits = 0;
	                    continue;
	                case 'measure-unit':
	                case 'unit':
	                    result.style = 'unit';
	                    result.unit = icuUnitToEcma(token.options[0]);
	                    continue;
	                case 'compact-short':
	                case 'K':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'short';
	                    continue;
	                case 'compact-long':
	                case 'KK':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'long';
	                    continue;
	                case 'scientific':
	                    result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'engineering':
	                    result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'notation-simple':
	                    result.notation = 'standard';
	                    continue;
	                // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	                case 'unit-width-narrow':
	                    result.currencyDisplay = 'narrowSymbol';
	                    result.unitDisplay = 'narrow';
	                    continue;
	                case 'unit-width-short':
	                    result.currencyDisplay = 'code';
	                    result.unitDisplay = 'short';
	                    continue;
	                case 'unit-width-full-name':
	                    result.currencyDisplay = 'name';
	                    result.unitDisplay = 'long';
	                    continue;
	                case 'unit-width-iso-code':
	                    result.currencyDisplay = 'symbol';
	                    continue;
	                case 'scale':
	                    result.scale = parseFloat(token.options[0]);
	                    continue;
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	                case 'integer-width':
	                    if (token.options.length > 1) {
	                        throw new RangeError('integer-width stems only accept a single optional option');
	                    }
	                    token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
	                        if (g1) {
	                            result.minimumIntegerDigits = g2.length;
	                        }
	                        else if (g3 && g4) {
	                            throw new Error('We currently do not support maximum integer digits');
	                        }
	                        else if (g5) {
	                            throw new Error('We currently do not support exact integer digits');
	                        }
	                        return '';
	                    });
	                    continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	            if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
	                result.minimumIntegerDigits = token.stem.length;
	                continue;
	            }
	            if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	                // Precision
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
	                // precision-integer case
	                if (token.options.length > 1) {
	                    throw new RangeError('Fraction-precision stems only accept a single optional option');
	                }
	                token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
	                    // .000* case (before ICU67 it was .000+)
	                    if (g2 === '*') {
	                        result.minimumFractionDigits = g1.length;
	                    }
	                    // .### case
	                    else if (g3 && g3[0] === '#') {
	                        result.maximumFractionDigits = g3.length;
	                    }
	                    // .00## case
	                    else if (g4 && g5) {
	                        result.minimumFractionDigits = g4.length;
	                        result.maximumFractionDigits = g4.length + g5.length;
	                    }
	                    else {
	                        result.minimumFractionDigits = g1.length;
	                        result.maximumFractionDigits = g1.length;
	                    }
	                    return '';
	                });
	                var opt = token.options[0];
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
	                if (opt === 'w') {
	                    result = __assign(__assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
	                }
	                else if (opt) {
	                    result = __assign(__assign({}, result), parseSignificantPrecision(opt));
	                }
	                continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
	            if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	                result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
	                continue;
	            }
	            var signOpts = parseSign(token.stem);
	            if (signOpts) {
	                result = __assign(__assign({}, result), signOpts);
	            }
	            var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
	            if (conciseScientificAndEngineeringOpts) {
	                result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
	            }
	        }
	        return result;
	    }

	    // @generated from time-data-gen.ts
	    // prettier-ignore  
	    var timeData = {
	        "AX": [
	            "H"
	        ],
	        "BQ": [
	            "H"
	        ],
	        "CP": [
	            "H"
	        ],
	        "CZ": [
	            "H"
	        ],
	        "DK": [
	            "H"
	        ],
	        "FI": [
	            "H"
	        ],
	        "ID": [
	            "H"
	        ],
	        "IS": [
	            "H"
	        ],
	        "ML": [
	            "H"
	        ],
	        "NE": [
	            "H"
	        ],
	        "RU": [
	            "H"
	        ],
	        "SE": [
	            "H"
	        ],
	        "SJ": [
	            "H"
	        ],
	        "SK": [
	            "H"
	        ],
	        "AS": [
	            "h",
	            "H"
	        ],
	        "BT": [
	            "h",
	            "H"
	        ],
	        "DJ": [
	            "h",
	            "H"
	        ],
	        "ER": [
	            "h",
	            "H"
	        ],
	        "GH": [
	            "h",
	            "H"
	        ],
	        "IN": [
	            "h",
	            "H"
	        ],
	        "LS": [
	            "h",
	            "H"
	        ],
	        "PG": [
	            "h",
	            "H"
	        ],
	        "PW": [
	            "h",
	            "H"
	        ],
	        "SO": [
	            "h",
	            "H"
	        ],
	        "TO": [
	            "h",
	            "H"
	        ],
	        "VU": [
	            "h",
	            "H"
	        ],
	        "WS": [
	            "h",
	            "H"
	        ],
	        "001": [
	            "H",
	            "h"
	        ],
	        "AL": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "TD": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "ca-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "fr-CA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "gl-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-CH": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-IT": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "LU": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "NP": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "PF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SC": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SN": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "TF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "VA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CY": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "GR": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "CO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "DO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KP": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "NA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "VE": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "AC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "AI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BW": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BZ": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "DG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "FK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GB": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IM": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IO": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "JE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "LT": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MS": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NF": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NR": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NU": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "PN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SH": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "TA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "ZA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "af-ZA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "AR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CL": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CU": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "EA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BO": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-EC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-ES": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-GQ": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-PE": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "GT": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "HN": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "IC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KG": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KM": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "LK": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MX": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "NI": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "PY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "SV": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "UY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "JP": [
	            "H",
	            "h",
	            "K"
	        ],
	        "AD": [
	            "H",
	            "hB"
	        ],
	        "AM": [
	            "H",
	            "hB"
	        ],
	        "AO": [
	            "H",
	            "hB"
	        ],
	        "AT": [
	            "H",
	            "hB"
	        ],
	        "AW": [
	            "H",
	            "hB"
	        ],
	        "BE": [
	            "H",
	            "hB"
	        ],
	        "BF": [
	            "H",
	            "hB"
	        ],
	        "BJ": [
	            "H",
	            "hB"
	        ],
	        "BL": [
	            "H",
	            "hB"
	        ],
	        "BR": [
	            "H",
	            "hB"
	        ],
	        "CG": [
	            "H",
	            "hB"
	        ],
	        "CI": [
	            "H",
	            "hB"
	        ],
	        "CV": [
	            "H",
	            "hB"
	        ],
	        "DE": [
	            "H",
	            "hB"
	        ],
	        "EE": [
	            "H",
	            "hB"
	        ],
	        "FR": [
	            "H",
	            "hB"
	        ],
	        "GA": [
	            "H",
	            "hB"
	        ],
	        "GF": [
	            "H",
	            "hB"
	        ],
	        "GN": [
	            "H",
	            "hB"
	        ],
	        "GP": [
	            "H",
	            "hB"
	        ],
	        "GW": [
	            "H",
	            "hB"
	        ],
	        "HR": [
	            "H",
	            "hB"
	        ],
	        "IL": [
	            "H",
	            "hB"
	        ],
	        "IT": [
	            "H",
	            "hB"
	        ],
	        "KZ": [
	            "H",
	            "hB"
	        ],
	        "MC": [
	            "H",
	            "hB"
	        ],
	        "MD": [
	            "H",
	            "hB"
	        ],
	        "MF": [
	            "H",
	            "hB"
	        ],
	        "MQ": [
	            "H",
	            "hB"
	        ],
	        "MZ": [
	            "H",
	            "hB"
	        ],
	        "NC": [
	            "H",
	            "hB"
	        ],
	        "NL": [
	            "H",
	            "hB"
	        ],
	        "PM": [
	            "H",
	            "hB"
	        ],
	        "PT": [
	            "H",
	            "hB"
	        ],
	        "RE": [
	            "H",
	            "hB"
	        ],
	        "RO": [
	            "H",
	            "hB"
	        ],
	        "SI": [
	            "H",
	            "hB"
	        ],
	        "SR": [
	            "H",
	            "hB"
	        ],
	        "ST": [
	            "H",
	            "hB"
	        ],
	        "TG": [
	            "H",
	            "hB"
	        ],
	        "TR": [
	            "H",
	            "hB"
	        ],
	        "WF": [
	            "H",
	            "hB"
	        ],
	        "YT": [
	            "H",
	            "hB"
	        ],
	        "BD": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "PK": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "AZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BG": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "CH": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "GE": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "LI": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "ME": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "RS": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "XK": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "AG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "AU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "CA": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "DM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "en-001": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FJ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GD": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "JM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KN": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LR": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MH": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MP": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MW": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "NZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SL": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TT": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "UM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "US": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "ZM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BO": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "EC": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "ES": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "GQ": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "PE": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "AE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "ar-001": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "BH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "DZ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EG": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "HK": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "IQ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "JO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "KW": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LB": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MR": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "OM": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PS": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "QA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SD": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "TN": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "YE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "AF": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "LA": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "CN": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "LV": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "TL": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "zu-ZA": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "CD": [
	            "hB",
	            "H"
	        ],
	        "IR": [
	            "hB",
	            "H"
	        ],
	        "hi-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "kn-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "ml-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "te-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "KH": [
	            "hB",
	            "h",
	            "H",
	            "hb"
	        ],
	        "ta-IN": [
	            "hB",
	            "h",
	            "hb",
	            "H"
	        ],
	        "BN": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "MY": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "ET": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "gu-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "mr-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "pa-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "TW": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "KE": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "MM": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "TZ": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "UG": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ]
	    };

	    /**
	     * Returns the best matching date time pattern if a date time skeleton
	     * pattern is provided with a locale. Follows the Unicode specification:
	     * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
	     * @param skeleton date time skeleton pattern that possibly includes j, J or C
	     * @param locale
	     */
	    function getBestPattern(skeleton, locale) {
	        var skeletonCopy = '';
	        for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
	            var patternChar = skeleton.charAt(patternPos);
	            if (patternChar === 'j') {
	                var extraLength = 0;
	                while (patternPos + 1 < skeleton.length &&
	                    skeleton.charAt(patternPos + 1) === patternChar) {
	                    extraLength++;
	                    patternPos++;
	                }
	                var hourLen = 1 + (extraLength & 1);
	                var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
	                var dayPeriodChar = 'a';
	                var hourChar = getDefaultHourSymbolFromLocale(locale);
	                if (hourChar == 'H' || hourChar == 'k') {
	                    dayPeriodLen = 0;
	                }
	                while (dayPeriodLen-- > 0) {
	                    skeletonCopy += dayPeriodChar;
	                }
	                while (hourLen-- > 0) {
	                    skeletonCopy = hourChar + skeletonCopy;
	                }
	            }
	            else if (patternChar === 'J') {
	                skeletonCopy += 'H';
	            }
	            else {
	                skeletonCopy += patternChar;
	            }
	        }
	        return skeletonCopy;
	    }
	    /**
	     * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
	     * of the given `locale` to the corresponding time pattern.
	     * @param locale
	     */
	    function getDefaultHourSymbolFromLocale(locale) {
	        var hourCycle = locale.hourCycle;
	        if (hourCycle === undefined &&
	            // @ts-ignore hourCycle(s) is not identified yet
	            locale.hourCycles &&
	            // @ts-ignore
	            locale.hourCycles.length) {
	            // @ts-ignore
	            hourCycle = locale.hourCycles[0];
	        }
	        if (hourCycle) {
	            switch (hourCycle) {
	                case 'h24':
	                    return 'k';
	                case 'h23':
	                    return 'H';
	                case 'h12':
	                    return 'h';
	                case 'h11':
	                    return 'K';
	                default:
	                    throw new Error('Invalid hourCycle');
	            }
	        }
	        // TODO: Once hourCycle is fully supported remove the following with data generation
	        var languageTag = locale.language;
	        var regionTag;
	        if (languageTag !== 'root') {
	            regionTag = locale.maximize().region;
	        }
	        var hourCycles = timeData[regionTag || ''] ||
	            timeData[languageTag || ''] ||
	            timeData["".concat(languageTag, "-001")] ||
	            timeData['001'];
	        return hourCycles[0];
	    }

	    var _a;
	    var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
	    var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
	    function createLocation(start, end) {
	        return { start: start, end: end };
	    }
	    // #region Ponyfills
	    // Consolidate these variables up top for easier toggling during debugging
	    var hasNativeStartsWith = !!String.prototype.startsWith;
	    var hasNativeFromCodePoint = !!String.fromCodePoint;
	    var hasNativeFromEntries = !!Object.fromEntries;
	    var hasNativeCodePointAt = !!String.prototype.codePointAt;
	    var hasTrimStart = !!String.prototype.trimStart;
	    var hasTrimEnd = !!String.prototype.trimEnd;
	    var hasNativeIsSafeInteger = !!Number.isSafeInteger;
	    var isSafeInteger = hasNativeIsSafeInteger
	        ? Number.isSafeInteger
	        : function (n) {
	            return (typeof n === 'number' &&
	                isFinite(n) &&
	                Math.floor(n) === n &&
	                Math.abs(n) <= 0x1fffffffffffff);
	        };
	    // IE11 does not support y and u.
	    var REGEX_SUPPORTS_U_AND_Y = true;
	    try {
	        var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        /**
	         * legacy Edge or Xbox One browser
	         * Unicode flag support: supported
	         * Pattern_Syntax support: not supported
	         * See https://github.com/formatjs/formatjs/issues/2822
	         */
	        REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
	    }
	    catch (_) {
	        REGEX_SUPPORTS_U_AND_Y = false;
	    }
	    var startsWith = hasNativeStartsWith
	        ? // Native
	            function startsWith(s, search, position) {
	                return s.startsWith(search, position);
	            }
	        : // For IE11
	            function startsWith(s, search, position) {
	                return s.slice(position, position + search.length) === search;
	            };
	    var fromCodePoint = hasNativeFromCodePoint
	        ? String.fromCodePoint
	        : // IE11
	            function fromCodePoint() {
	                var codePoints = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    codePoints[_i] = arguments[_i];
	                }
	                var elements = '';
	                var length = codePoints.length;
	                var i = 0;
	                var code;
	                while (length > i) {
	                    code = codePoints[i++];
	                    if (code > 0x10ffff)
	                        throw RangeError(code + ' is not a valid code point');
	                    elements +=
	                        code < 0x10000
	                            ? String.fromCharCode(code)
	                            : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
	                }
	                return elements;
	            };
	    var fromEntries = 
	    // native
	    hasNativeFromEntries
	        ? Object.fromEntries
	        : // Ponyfill
	            function fromEntries(entries) {
	                var obj = {};
	                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                    var _a = entries_1[_i], k = _a[0], v = _a[1];
	                    obj[k] = v;
	                }
	                return obj;
	            };
	    var codePointAt = hasNativeCodePointAt
	        ? // Native
	            function codePointAt(s, index) {
	                return s.codePointAt(index);
	            }
	        : // IE 11
	            function codePointAt(s, index) {
	                var size = s.length;
	                if (index < 0 || index >= size) {
	                    return undefined;
	                }
	                var first = s.charCodeAt(index);
	                var second;
	                return first < 0xd800 ||
	                    first > 0xdbff ||
	                    index + 1 === size ||
	                    (second = s.charCodeAt(index + 1)) < 0xdc00 ||
	                    second > 0xdfff
	                    ? first
	                    : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
	            };
	    var trimStart = hasTrimStart
	        ? // Native
	            function trimStart(s) {
	                return s.trimStart();
	            }
	        : // Ponyfill
	            function trimStart(s) {
	                return s.replace(SPACE_SEPARATOR_START_REGEX, '');
	            };
	    var trimEnd = hasTrimEnd
	        ? // Native
	            function trimEnd(s) {
	                return s.trimEnd();
	            }
	        : // Ponyfill
	            function trimEnd(s) {
	                return s.replace(SPACE_SEPARATOR_END_REGEX, '');
	            };
	    // Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
	    function RE(s, flag) {
	        return new RegExp(s, flag);
	    }
	    // #endregion
	    var matchIdentifierAtIndex;
	    if (REGEX_SUPPORTS_U_AND_Y) {
	        // Native
	        var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var _a;
	            IDENTIFIER_PREFIX_RE_1.lastIndex = index;
	            var match = IDENTIFIER_PREFIX_RE_1.exec(s);
	            return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
	        };
	    }
	    else {
	        // IE11
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var match = [];
	            while (true) {
	                var c = codePointAt(s, index);
	                if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
	                    break;
	                }
	                match.push(c);
	                index += c >= 0x10000 ? 2 : 1;
	            }
	            return fromCodePoint.apply(void 0, match);
	        };
	    }
	    var Parser = /** @class */ (function () {
	        function Parser(message, options) {
	            if (options === void 0) { options = {}; }
	            this.message = message;
	            this.position = { offset: 0, line: 1, column: 1 };
	            this.ignoreTag = !!options.ignoreTag;
	            this.locale = options.locale;
	            this.requiresOtherClause = !!options.requiresOtherClause;
	            this.shouldParseSkeletons = !!options.shouldParseSkeletons;
	        }
	        Parser.prototype.parse = function () {
	            if (this.offset() !== 0) {
	                throw Error('parser can only be used once');
	            }
	            return this.parseMessage(0, '', false);
	        };
	        Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
	            var elements = [];
	            while (!this.isEOF()) {
	                var char = this.char();
	                if (char === 123 /* `{` */) {
	                    var result = this.parseArgument(nestingLevel, expectingCloseTag);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else if (char === 125 /* `}` */ && nestingLevel > 0) {
	                    break;
	                }
	                else if (char === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
	                    var position = this.clonePosition();
	                    this.bump();
	                    elements.push({
	                        type: TYPE.pound,
	                        location: createLocation(position, this.clonePosition()),
	                    });
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    this.peek() === 47 // char code for '/'
	                ) {
	                    if (expectingCloseTag) {
	                        break;
	                    }
	                    else {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
	                    }
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    _isAlpha(this.peek() || 0)) {
	                    var result = this.parseTag(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else {
	                    var result = this.parseLiteral(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	            }
	            return { val: elements, err: null };
	        };
	        /**
	         * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	         * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	         * are accepted:
	         *
	         * ```
	         * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	         * tagName ::= [a-z] (PENChar)*
	         * PENChar ::=
	         *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	         *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	         *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	         * ```
	         *
	         * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	         * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	         * since other tag-based engines like React allow it
	         */
	        Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
	            var startPosition = this.clonePosition();
	            this.bump(); // `<`
	            var tagName = this.parseTagName();
	            this.bumpSpace();
	            if (this.bumpIf('/>')) {
	                // Self closing tag
	                return {
	                    val: {
	                        type: TYPE.literal,
	                        value: "<".concat(tagName, "/>"),
	                        location: createLocation(startPosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            else if (this.bumpIf('>')) {
	                var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
	                if (childrenResult.err) {
	                    return childrenResult;
	                }
	                var children = childrenResult.val;
	                // Expecting a close tag
	                var endTagStartPosition = this.clonePosition();
	                if (this.bumpIf('</')) {
	                    if (this.isEOF() || !_isAlpha(this.char())) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    var closingTagNameStartPosition = this.clonePosition();
	                    var closingTagName = this.parseTagName();
	                    if (tagName !== closingTagName) {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
	                    }
	                    this.bumpSpace();
	                    if (!this.bumpIf('>')) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    return {
	                        val: {
	                            type: TYPE.tag,
	                            value: tagName,
	                            children: children,
	                            location: createLocation(startPosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                else {
	                    return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
	                }
	            }
	            else {
	                return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
	            }
	        };
	        /**
	         * This method assumes that the caller has peeked ahead for the first tag character.
	         */
	        Parser.prototype.parseTagName = function () {
	            var startOffset = this.offset();
	            this.bump(); // the first tag name character
	            while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
	                this.bump();
	            }
	            return this.message.slice(startOffset, this.offset());
	        };
	        Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
	            var start = this.clonePosition();
	            var value = '';
	            while (true) {
	                var parseQuoteResult = this.tryParseQuote(parentArgType);
	                if (parseQuoteResult) {
	                    value += parseQuoteResult;
	                    continue;
	                }
	                var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
	                if (parseUnquotedResult) {
	                    value += parseUnquotedResult;
	                    continue;
	                }
	                var parseLeftAngleResult = this.tryParseLeftAngleBracket();
	                if (parseLeftAngleResult) {
	                    value += parseLeftAngleResult;
	                    continue;
	                }
	                break;
	            }
	            var location = createLocation(start, this.clonePosition());
	            return {
	                val: { type: TYPE.literal, value: value, location: location },
	                err: null,
	            };
	        };
	        Parser.prototype.tryParseLeftAngleBracket = function () {
	            if (!this.isEOF() &&
	                this.char() === 60 /* `<` */ &&
	                (this.ignoreTag ||
	                    // If at the opening tag or closing tag position, bail.
	                    !_isAlphaOrSlash(this.peek() || 0))) {
	                this.bump(); // `<`
	                return '<';
	            }
	            return null;
	        };
	        /**
	         * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	         * a character that requires quoting (that is, "only where needed"), and works the same in
	         * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	         */
	        Parser.prototype.tryParseQuote = function (parentArgType) {
	            if (this.isEOF() || this.char() !== 39 /* `'` */) {
	                return null;
	            }
	            // Parse escaped char following the apostrophe, or early return if there is no escaped char.
	            // Check if is valid escaped character
	            switch (this.peek()) {
	                case 39 /* `'` */:
	                    // double quote, should return as a single quote.
	                    this.bump();
	                    this.bump();
	                    return "'";
	                // '{', '<', '>', '}'
	                case 123:
	                case 60:
	                case 62:
	                case 125:
	                    break;
	                case 35: // '#'
	                    if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
	                        break;
	                    }
	                    return null;
	                default:
	                    return null;
	            }
	            this.bump(); // apostrophe
	            var codePoints = [this.char()]; // escaped char
	            this.bump();
	            // read chars until the optional closing apostrophe is found
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch === 39 /* `'` */) {
	                    if (this.peek() === 39 /* `'` */) {
	                        codePoints.push(39);
	                        // Bump one more time because we need to skip 2 characters.
	                        this.bump();
	                    }
	                    else {
	                        // Optional closing apostrophe.
	                        this.bump();
	                        break;
	                    }
	                }
	                else {
	                    codePoints.push(ch);
	                }
	                this.bump();
	            }
	            return fromCodePoint.apply(void 0, codePoints);
	        };
	        Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
	            if (this.isEOF()) {
	                return null;
	            }
	            var ch = this.char();
	            if (ch === 60 /* `<` */ ||
	                ch === 123 /* `{` */ ||
	                (ch === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
	                (ch === 125 /* `}` */ && nestingLevel > 0)) {
	                return null;
	            }
	            else {
	                this.bump();
	                return fromCodePoint(ch);
	            }
	        };
	        Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
	            var openingBracePosition = this.clonePosition();
	            this.bump(); // `{`
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            if (this.char() === 125 /* `}` */) {
	                this.bump();
	                return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            // argument name
	            var value = this.parseIdentifierIfPossible().value;
	            if (!value) {
	                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            switch (this.char()) {
	                // Simple argument: `{name}`
	                case 125 /* `}` */: {
	                    this.bump(); // `}`
	                    return {
	                        val: {
	                            type: TYPE.argument,
	                            // value does not include the opening and closing braces.
	                            value: value,
	                            location: createLocation(openingBracePosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                // Argument with options: `{name, format, ...}`
	                case 44 /* `,` */: {
	                    this.bump(); // `,`
	                    this.bumpSpace();
	                    if (this.isEOF()) {
	                        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	                    }
	                    return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
	                }
	                default:
	                    return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	        };
	        /**
	         * Advance the parser until the end of the identifier, if it is currently on
	         * an identifier character. Return an empty string otherwise.
	         */
	        Parser.prototype.parseIdentifierIfPossible = function () {
	            var startingPosition = this.clonePosition();
	            var startOffset = this.offset();
	            var value = matchIdentifierAtIndex(this.message, startOffset);
	            var endOffset = startOffset + value.length;
	            this.bumpTo(endOffset);
	            var endPosition = this.clonePosition();
	            var location = createLocation(startingPosition, endPosition);
	            return { value: value, location: location };
	        };
	        Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
	            var _a;
	            // Parse this range:
	            // {name, type, style}
	            //        ^---^
	            var typeStartPosition = this.clonePosition();
	            var argType = this.parseIdentifierIfPossible().value;
	            var typeEndPosition = this.clonePosition();
	            switch (argType) {
	                case '':
	                    // Expecting a style string number, date, time, plural, selectordinal, or select.
	                    return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	                case 'number':
	                case 'date':
	                case 'time': {
	                    // Parse this range:
	                    // {name, number, style}
	                    //              ^-------^
	                    this.bumpSpace();
	                    var styleAndLocation = null;
	                    if (this.bumpIf(',')) {
	                        this.bumpSpace();
	                        var styleStartPosition = this.clonePosition();
	                        var result = this.parseSimpleArgStyleIfPossible();
	                        if (result.err) {
	                            return result;
	                        }
	                        var style = trimEnd(result.val);
	                        if (style.length === 0) {
	                            return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        var styleLocation = createLocation(styleStartPosition, this.clonePosition());
	                        styleAndLocation = { style: style, styleLocation: styleLocation };
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_1 = createLocation(openingBracePosition, this.clonePosition());
	                    // Extract style or skeleton
	                    if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
	                        // Skeleton starts with `::`.
	                        var skeleton = trimStart(styleAndLocation.style.slice(2));
	                        if (argType === 'number') {
	                            var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
	                            if (result.err) {
	                                return result;
	                            }
	                            return {
	                                val: { type: TYPE.number, value: value, location: location_1, style: result.val },
	                                err: null,
	                            };
	                        }
	                        else {
	                            if (skeleton.length === 0) {
	                                return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
	                            }
	                            var dateTimePattern = skeleton;
	                            // Get "best match" pattern only if locale is passed, if not, let it
	                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
	                            // for unsupported patterns.
	                            if (this.locale) {
	                                dateTimePattern = getBestPattern(skeleton, this.locale);
	                            }
	                            var style = {
	                                type: SKELETON_TYPE.dateTime,
	                                pattern: dateTimePattern,
	                                location: styleAndLocation.styleLocation,
	                                parsedOptions: this.shouldParseSkeletons
	                                    ? parseDateTimeSkeleton(dateTimePattern)
	                                    : {},
	                            };
	                            var type = argType === 'date' ? TYPE.date : TYPE.time;
	                            return {
	                                val: { type: type, value: value, location: location_1, style: style },
	                                err: null,
	                            };
	                        }
	                    }
	                    // Regular style or no style.
	                    return {
	                        val: {
	                            type: argType === 'number'
	                                ? TYPE.number
	                                : argType === 'date'
	                                    ? TYPE.date
	                                    : TYPE.time,
	                            value: value,
	                            location: location_1,
	                            style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
	                        },
	                        err: null,
	                    };
	                }
	                case 'plural':
	                case 'selectordinal':
	                case 'select': {
	                    // Parse this range:
	                    // {name, plural, options}
	                    //              ^---------^
	                    var typeEndPosition_1 = this.clonePosition();
	                    this.bumpSpace();
	                    if (!this.bumpIf(',')) {
	                        return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)));
	                    }
	                    this.bumpSpace();
	                    // Parse offset:
	                    // {name, plural, offset:1, options}
	                    //                ^-----^
	                    //
	                    // or the first option:
	                    //
	                    // {name, plural, one {...} other {...}}
	                    //                ^--^
	                    var identifierAndLocation = this.parseIdentifierIfPossible();
	                    var pluralOffset = 0;
	                    if (argType !== 'select' && identifierAndLocation.value === 'offset') {
	                        if (!this.bumpIf(':')) {
	                            return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        this.bumpSpace();
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
	                        if (result.err) {
	                            return result;
	                        }
	                        // Parse another identifier for option parsing
	                        this.bumpSpace();
	                        identifierAndLocation = this.parseIdentifierIfPossible();
	                        pluralOffset = result.val;
	                    }
	                    var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
	                    if (optionsResult.err) {
	                        return optionsResult;
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_2 = createLocation(openingBracePosition, this.clonePosition());
	                    if (argType === 'select') {
	                        return {
	                            val: {
	                                type: TYPE.select,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                    else {
	                        return {
	                            val: {
	                                type: TYPE.plural,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                offset: pluralOffset,
	                                pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                }
	                default:
	                    return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	            }
	        };
	        Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
	            // Parse: {value, number, ::currency/GBP }
	            //
	            if (this.isEOF() || this.char() !== 125 /* `}` */) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bump(); // `}`
	            return { val: true, err: null };
	        };
	        /**
	         * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	         */
	        Parser.prototype.parseSimpleArgStyleIfPossible = function () {
	            var nestedBraces = 0;
	            var startPosition = this.clonePosition();
	            while (!this.isEOF()) {
	                var ch = this.char();
	                switch (ch) {
	                    case 39 /* `'` */: {
	                        // Treat apostrophe as quoting but include it in the style part.
	                        // Find the end of the quoted literal text.
	                        this.bump();
	                        var apostrophePosition = this.clonePosition();
	                        if (!this.bumpUntil("'")) {
	                            return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
	                        }
	                        this.bump();
	                        break;
	                    }
	                    case 123 /* `{` */: {
	                        nestedBraces += 1;
	                        this.bump();
	                        break;
	                    }
	                    case 125 /* `}` */: {
	                        if (nestedBraces > 0) {
	                            nestedBraces -= 1;
	                        }
	                        else {
	                            return {
	                                val: this.message.slice(startPosition.offset, this.offset()),
	                                err: null,
	                            };
	                        }
	                        break;
	                    }
	                    default:
	                        this.bump();
	                        break;
	                }
	            }
	            return {
	                val: this.message.slice(startPosition.offset, this.offset()),
	                err: null,
	            };
	        };
	        Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
	            var tokens = [];
	            try {
	                tokens = parseNumberSkeletonFromString(skeleton);
	            }
	            catch (e) {
	                return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
	            }
	            return {
	                val: {
	                    type: SKELETON_TYPE.number,
	                    tokens: tokens,
	                    location: location,
	                    parsedOptions: this.shouldParseSkeletons
	                        ? parseNumberSkeleton(tokens)
	                        : {},
	                },
	                err: null,
	            };
	        };
	        /**
	         * @param nesting_level The current nesting level of messages.
	         *     This can be positive when parsing message fragment in select or plural argument options.
	         * @param parent_arg_type The parent argument's type.
	         * @param parsed_first_identifier If provided, this is the first identifier-like selector of
	         *     the argument. It is a by-product of a previous parsing attempt.
	         * @param expecting_close_tag If true, this message is directly or indirectly nested inside
	         *     between a pair of opening and closing tags. The nested message will not parse beyond
	         *     the closing tag boundary.
	         */
	        Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
	            var _a;
	            var hasOtherClause = false;
	            var options = [];
	            var parsedSelectors = new Set();
	            var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
	            // Parse:
	            // one {one apple}
	            // ^--^
	            while (true) {
	                if (selector.length === 0) {
	                    var startPosition = this.clonePosition();
	                    if (parentArgType !== 'select' && this.bumpIf('=')) {
	                        // Try parse `={number}` selector
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
	                        if (result.err) {
	                            return result;
	                        }
	                        selectorLocation = createLocation(startPosition, this.clonePosition());
	                        selector = this.message.slice(startPosition.offset, this.offset());
	                    }
	                    else {
	                        break;
	                    }
	                }
	                // Duplicate selector clauses
	                if (parsedSelectors.has(selector)) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
	                        : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
	                }
	                if (selector === 'other') {
	                    hasOtherClause = true;
	                }
	                // Parse:
	                // one {one apple}
	                //     ^----------^
	                this.bumpSpace();
	                var openingBracePosition = this.clonePosition();
	                if (!this.bumpIf('{')) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
	                        : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
	                }
	                var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
	                if (fragmentResult.err) {
	                    return fragmentResult;
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                options.push([
	                    selector,
	                    {
	                        value: fragmentResult.val,
	                        location: createLocation(openingBracePosition, this.clonePosition()),
	                    },
	                ]);
	                // Keep track of the existing selectors
	                parsedSelectors.add(selector);
	                // Prep next selector clause.
	                this.bumpSpace();
	                (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
	            }
	            if (options.length === 0) {
	                return this.error(parentArgType === 'select'
	                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
	                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            if (this.requiresOtherClause && !hasOtherClause) {
	                return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            return { val: options, err: null };
	        };
	        Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
	            var sign = 1;
	            var startingPosition = this.clonePosition();
	            if (this.bumpIf('+')) ;
	            else if (this.bumpIf('-')) {
	                sign = -1;
	            }
	            var hasDigits = false;
	            var decimal = 0;
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
	                    hasDigits = true;
	                    decimal = decimal * 10 + (ch - 48);
	                    this.bump();
	                }
	                else {
	                    break;
	                }
	            }
	            var location = createLocation(startingPosition, this.clonePosition());
	            if (!hasDigits) {
	                return this.error(expectNumberError, location);
	            }
	            decimal *= sign;
	            if (!isSafeInteger(decimal)) {
	                return this.error(invalidNumberError, location);
	            }
	            return { val: decimal, err: null };
	        };
	        Parser.prototype.offset = function () {
	            return this.position.offset;
	        };
	        Parser.prototype.isEOF = function () {
	            return this.offset() === this.message.length;
	        };
	        Parser.prototype.clonePosition = function () {
	            // This is much faster than `Object.assign` or spread.
	            return {
	                offset: this.position.offset,
	                line: this.position.line,
	                column: this.position.column,
	            };
	        };
	        /**
	         * Return the code point at the current position of the parser.
	         * Throws if the index is out of bound.
	         */
	        Parser.prototype.char = function () {
	            var offset = this.position.offset;
	            if (offset >= this.message.length) {
	                throw Error('out of bound');
	            }
	            var code = codePointAt(this.message, offset);
	            if (code === undefined) {
	                throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
	            }
	            return code;
	        };
	        Parser.prototype.error = function (kind, location) {
	            return {
	                val: null,
	                err: {
	                    kind: kind,
	                    message: this.message,
	                    location: location,
	                },
	            };
	        };
	        /** Bump the parser to the next UTF-16 code unit. */
	        Parser.prototype.bump = function () {
	            if (this.isEOF()) {
	                return;
	            }
	            var code = this.char();
	            if (code === 10 /* '\n' */) {
	                this.position.line += 1;
	                this.position.column = 1;
	                this.position.offset += 1;
	            }
	            else {
	                this.position.column += 1;
	                // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
	                this.position.offset += code < 0x10000 ? 1 : 2;
	            }
	        };
	        /**
	         * If the substring starting at the current position of the parser has
	         * the given prefix, then bump the parser to the character immediately
	         * following the prefix and return true. Otherwise, don't bump the parser
	         * and return false.
	         */
	        Parser.prototype.bumpIf = function (prefix) {
	            if (startsWith(this.message, prefix, this.offset())) {
	                for (var i = 0; i < prefix.length; i++) {
	                    this.bump();
	                }
	                return true;
	            }
	            return false;
	        };
	        /**
	         * Bump the parser until the pattern character is found and return `true`.
	         * Otherwise bump to the end of the file and return `false`.
	         */
	        Parser.prototype.bumpUntil = function (pattern) {
	            var currentOffset = this.offset();
	            var index = this.message.indexOf(pattern, currentOffset);
	            if (index >= 0) {
	                this.bumpTo(index);
	                return true;
	            }
	            else {
	                this.bumpTo(this.message.length);
	                return false;
	            }
	        };
	        /**
	         * Bump the parser to the target offset.
	         * If target offset is beyond the end of the input, bump the parser to the end of the input.
	         */
	        Parser.prototype.bumpTo = function (targetOffset) {
	            if (this.offset() > targetOffset) {
	                throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
	            }
	            targetOffset = Math.min(targetOffset, this.message.length);
	            while (true) {
	                var offset = this.offset();
	                if (offset === targetOffset) {
	                    break;
	                }
	                if (offset > targetOffset) {
	                    throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
	                }
	                this.bump();
	                if (this.isEOF()) {
	                    break;
	                }
	            }
	        };
	        /** advance the parser through all whitespace to the next non-whitespace code unit. */
	        Parser.prototype.bumpSpace = function () {
	            while (!this.isEOF() && _isWhiteSpace(this.char())) {
	                this.bump();
	            }
	        };
	        /**
	         * Peek at the *next* Unicode codepoint in the input without advancing the parser.
	         * If the input has been exhausted, then this returns null.
	         */
	        Parser.prototype.peek = function () {
	            if (this.isEOF()) {
	                return null;
	            }
	            var code = this.char();
	            var offset = this.offset();
	            var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
	            return nextCode !== null && nextCode !== void 0 ? nextCode : null;
	        };
	        return Parser;
	    }());
	    /**
	     * This check if codepoint is alphabet (lower & uppercase)
	     * @param codepoint
	     * @returns
	     */
	    function _isAlpha(codepoint) {
	        return ((codepoint >= 97 && codepoint <= 122) ||
	            (codepoint >= 65 && codepoint <= 90));
	    }
	    function _isAlphaOrSlash(codepoint) {
	        return _isAlpha(codepoint) || codepoint === 47; /* '/' */
	    }
	    /** See `parseTag` function docs. */
	    function _isPotentialElementNameChar(c) {
	        return (c === 45 /* '-' */ ||
	            c === 46 /* '.' */ ||
	            (c >= 48 && c <= 57) /* 0..9 */ ||
	            c === 95 /* '_' */ ||
	            (c >= 97 && c <= 122) /** a..z */ ||
	            (c >= 65 && c <= 90) /* A..Z */ ||
	            c == 0xb7 ||
	            (c >= 0xc0 && c <= 0xd6) ||
	            (c >= 0xd8 && c <= 0xf6) ||
	            (c >= 0xf8 && c <= 0x37d) ||
	            (c >= 0x37f && c <= 0x1fff) ||
	            (c >= 0x200c && c <= 0x200d) ||
	            (c >= 0x203f && c <= 0x2040) ||
	            (c >= 0x2070 && c <= 0x218f) ||
	            (c >= 0x2c00 && c <= 0x2fef) ||
	            (c >= 0x3001 && c <= 0xd7ff) ||
	            (c >= 0xf900 && c <= 0xfdcf) ||
	            (c >= 0xfdf0 && c <= 0xfffd) ||
	            (c >= 0x10000 && c <= 0xeffff));
	    }
	    /**
	     * Code point equivalent of regex `\p{White_Space}`.
	     * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isWhiteSpace(c) {
	        return ((c >= 0x0009 && c <= 0x000d) ||
	            c === 0x0020 ||
	            c === 0x0085 ||
	            (c >= 0x200e && c <= 0x200f) ||
	            c === 0x2028 ||
	            c === 0x2029);
	    }
	    /**
	     * Code point equivalent of regex `\p{Pattern_Syntax}`.
	     * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isPatternSyntax(c) {
	        return ((c >= 0x0021 && c <= 0x0023) ||
	            c === 0x0024 ||
	            (c >= 0x0025 && c <= 0x0027) ||
	            c === 0x0028 ||
	            c === 0x0029 ||
	            c === 0x002a ||
	            c === 0x002b ||
	            c === 0x002c ||
	            c === 0x002d ||
	            (c >= 0x002e && c <= 0x002f) ||
	            (c >= 0x003a && c <= 0x003b) ||
	            (c >= 0x003c && c <= 0x003e) ||
	            (c >= 0x003f && c <= 0x0040) ||
	            c === 0x005b ||
	            c === 0x005c ||
	            c === 0x005d ||
	            c === 0x005e ||
	            c === 0x0060 ||
	            c === 0x007b ||
	            c === 0x007c ||
	            c === 0x007d ||
	            c === 0x007e ||
	            c === 0x00a1 ||
	            (c >= 0x00a2 && c <= 0x00a5) ||
	            c === 0x00a6 ||
	            c === 0x00a7 ||
	            c === 0x00a9 ||
	            c === 0x00ab ||
	            c === 0x00ac ||
	            c === 0x00ae ||
	            c === 0x00b0 ||
	            c === 0x00b1 ||
	            c === 0x00b6 ||
	            c === 0x00bb ||
	            c === 0x00bf ||
	            c === 0x00d7 ||
	            c === 0x00f7 ||
	            (c >= 0x2010 && c <= 0x2015) ||
	            (c >= 0x2016 && c <= 0x2017) ||
	            c === 0x2018 ||
	            c === 0x2019 ||
	            c === 0x201a ||
	            (c >= 0x201b && c <= 0x201c) ||
	            c === 0x201d ||
	            c === 0x201e ||
	            c === 0x201f ||
	            (c >= 0x2020 && c <= 0x2027) ||
	            (c >= 0x2030 && c <= 0x2038) ||
	            c === 0x2039 ||
	            c === 0x203a ||
	            (c >= 0x203b && c <= 0x203e) ||
	            (c >= 0x2041 && c <= 0x2043) ||
	            c === 0x2044 ||
	            c === 0x2045 ||
	            c === 0x2046 ||
	            (c >= 0x2047 && c <= 0x2051) ||
	            c === 0x2052 ||
	            c === 0x2053 ||
	            (c >= 0x2055 && c <= 0x205e) ||
	            (c >= 0x2190 && c <= 0x2194) ||
	            (c >= 0x2195 && c <= 0x2199) ||
	            (c >= 0x219a && c <= 0x219b) ||
	            (c >= 0x219c && c <= 0x219f) ||
	            c === 0x21a0 ||
	            (c >= 0x21a1 && c <= 0x21a2) ||
	            c === 0x21a3 ||
	            (c >= 0x21a4 && c <= 0x21a5) ||
	            c === 0x21a6 ||
	            (c >= 0x21a7 && c <= 0x21ad) ||
	            c === 0x21ae ||
	            (c >= 0x21af && c <= 0x21cd) ||
	            (c >= 0x21ce && c <= 0x21cf) ||
	            (c >= 0x21d0 && c <= 0x21d1) ||
	            c === 0x21d2 ||
	            c === 0x21d3 ||
	            c === 0x21d4 ||
	            (c >= 0x21d5 && c <= 0x21f3) ||
	            (c >= 0x21f4 && c <= 0x22ff) ||
	            (c >= 0x2300 && c <= 0x2307) ||
	            c === 0x2308 ||
	            c === 0x2309 ||
	            c === 0x230a ||
	            c === 0x230b ||
	            (c >= 0x230c && c <= 0x231f) ||
	            (c >= 0x2320 && c <= 0x2321) ||
	            (c >= 0x2322 && c <= 0x2328) ||
	            c === 0x2329 ||
	            c === 0x232a ||
	            (c >= 0x232b && c <= 0x237b) ||
	            c === 0x237c ||
	            (c >= 0x237d && c <= 0x239a) ||
	            (c >= 0x239b && c <= 0x23b3) ||
	            (c >= 0x23b4 && c <= 0x23db) ||
	            (c >= 0x23dc && c <= 0x23e1) ||
	            (c >= 0x23e2 && c <= 0x2426) ||
	            (c >= 0x2427 && c <= 0x243f) ||
	            (c >= 0x2440 && c <= 0x244a) ||
	            (c >= 0x244b && c <= 0x245f) ||
	            (c >= 0x2500 && c <= 0x25b6) ||
	            c === 0x25b7 ||
	            (c >= 0x25b8 && c <= 0x25c0) ||
	            c === 0x25c1 ||
	            (c >= 0x25c2 && c <= 0x25f7) ||
	            (c >= 0x25f8 && c <= 0x25ff) ||
	            (c >= 0x2600 && c <= 0x266e) ||
	            c === 0x266f ||
	            (c >= 0x2670 && c <= 0x2767) ||
	            c === 0x2768 ||
	            c === 0x2769 ||
	            c === 0x276a ||
	            c === 0x276b ||
	            c === 0x276c ||
	            c === 0x276d ||
	            c === 0x276e ||
	            c === 0x276f ||
	            c === 0x2770 ||
	            c === 0x2771 ||
	            c === 0x2772 ||
	            c === 0x2773 ||
	            c === 0x2774 ||
	            c === 0x2775 ||
	            (c >= 0x2794 && c <= 0x27bf) ||
	            (c >= 0x27c0 && c <= 0x27c4) ||
	            c === 0x27c5 ||
	            c === 0x27c6 ||
	            (c >= 0x27c7 && c <= 0x27e5) ||
	            c === 0x27e6 ||
	            c === 0x27e7 ||
	            c === 0x27e8 ||
	            c === 0x27e9 ||
	            c === 0x27ea ||
	            c === 0x27eb ||
	            c === 0x27ec ||
	            c === 0x27ed ||
	            c === 0x27ee ||
	            c === 0x27ef ||
	            (c >= 0x27f0 && c <= 0x27ff) ||
	            (c >= 0x2800 && c <= 0x28ff) ||
	            (c >= 0x2900 && c <= 0x2982) ||
	            c === 0x2983 ||
	            c === 0x2984 ||
	            c === 0x2985 ||
	            c === 0x2986 ||
	            c === 0x2987 ||
	            c === 0x2988 ||
	            c === 0x2989 ||
	            c === 0x298a ||
	            c === 0x298b ||
	            c === 0x298c ||
	            c === 0x298d ||
	            c === 0x298e ||
	            c === 0x298f ||
	            c === 0x2990 ||
	            c === 0x2991 ||
	            c === 0x2992 ||
	            c === 0x2993 ||
	            c === 0x2994 ||
	            c === 0x2995 ||
	            c === 0x2996 ||
	            c === 0x2997 ||
	            c === 0x2998 ||
	            (c >= 0x2999 && c <= 0x29d7) ||
	            c === 0x29d8 ||
	            c === 0x29d9 ||
	            c === 0x29da ||
	            c === 0x29db ||
	            (c >= 0x29dc && c <= 0x29fb) ||
	            c === 0x29fc ||
	            c === 0x29fd ||
	            (c >= 0x29fe && c <= 0x2aff) ||
	            (c >= 0x2b00 && c <= 0x2b2f) ||
	            (c >= 0x2b30 && c <= 0x2b44) ||
	            (c >= 0x2b45 && c <= 0x2b46) ||
	            (c >= 0x2b47 && c <= 0x2b4c) ||
	            (c >= 0x2b4d && c <= 0x2b73) ||
	            (c >= 0x2b74 && c <= 0x2b75) ||
	            (c >= 0x2b76 && c <= 0x2b95) ||
	            c === 0x2b96 ||
	            (c >= 0x2b97 && c <= 0x2bff) ||
	            (c >= 0x2e00 && c <= 0x2e01) ||
	            c === 0x2e02 ||
	            c === 0x2e03 ||
	            c === 0x2e04 ||
	            c === 0x2e05 ||
	            (c >= 0x2e06 && c <= 0x2e08) ||
	            c === 0x2e09 ||
	            c === 0x2e0a ||
	            c === 0x2e0b ||
	            c === 0x2e0c ||
	            c === 0x2e0d ||
	            (c >= 0x2e0e && c <= 0x2e16) ||
	            c === 0x2e17 ||
	            (c >= 0x2e18 && c <= 0x2e19) ||
	            c === 0x2e1a ||
	            c === 0x2e1b ||
	            c === 0x2e1c ||
	            c === 0x2e1d ||
	            (c >= 0x2e1e && c <= 0x2e1f) ||
	            c === 0x2e20 ||
	            c === 0x2e21 ||
	            c === 0x2e22 ||
	            c === 0x2e23 ||
	            c === 0x2e24 ||
	            c === 0x2e25 ||
	            c === 0x2e26 ||
	            c === 0x2e27 ||
	            c === 0x2e28 ||
	            c === 0x2e29 ||
	            (c >= 0x2e2a && c <= 0x2e2e) ||
	            c === 0x2e2f ||
	            (c >= 0x2e30 && c <= 0x2e39) ||
	            (c >= 0x2e3a && c <= 0x2e3b) ||
	            (c >= 0x2e3c && c <= 0x2e3f) ||
	            c === 0x2e40 ||
	            c === 0x2e41 ||
	            c === 0x2e42 ||
	            (c >= 0x2e43 && c <= 0x2e4f) ||
	            (c >= 0x2e50 && c <= 0x2e51) ||
	            c === 0x2e52 ||
	            (c >= 0x2e53 && c <= 0x2e7f) ||
	            (c >= 0x3001 && c <= 0x3003) ||
	            c === 0x3008 ||
	            c === 0x3009 ||
	            c === 0x300a ||
	            c === 0x300b ||
	            c === 0x300c ||
	            c === 0x300d ||
	            c === 0x300e ||
	            c === 0x300f ||
	            c === 0x3010 ||
	            c === 0x3011 ||
	            (c >= 0x3012 && c <= 0x3013) ||
	            c === 0x3014 ||
	            c === 0x3015 ||
	            c === 0x3016 ||
	            c === 0x3017 ||
	            c === 0x3018 ||
	            c === 0x3019 ||
	            c === 0x301a ||
	            c === 0x301b ||
	            c === 0x301c ||
	            c === 0x301d ||
	            (c >= 0x301e && c <= 0x301f) ||
	            c === 0x3020 ||
	            c === 0x3030 ||
	            c === 0xfd3e ||
	            c === 0xfd3f ||
	            (c >= 0xfe45 && c <= 0xfe46));
	    }

	    function pruneLocation(els) {
	        els.forEach(function (el) {
	            delete el.location;
	            if (isSelectElement(el) || isPluralElement(el)) {
	                for (var k in el.options) {
	                    delete el.options[k].location;
	                    pruneLocation(el.options[k].value);
	                }
	            }
	            else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if ((isDateElement(el) || isTimeElement(el)) &&
	                isDateTimeSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if (isTagElement(el)) {
	                pruneLocation(el.children);
	            }
	        });
	    }
	    function parse(message, opts) {
	        if (opts === void 0) { opts = {}; }
	        opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
	        var result = new Parser(message, opts).parse();
	        if (result.err) {
	            var error = SyntaxError(ErrorKind[result.err.kind]);
	            // @ts-expect-error Assign to error object
	            error.location = result.err.location;
	            // @ts-expect-error Assign to error object
	            error.originalMessage = result.err.message;
	            throw error;
	        }
	        if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
	            pruneLocation(result.val);
	        }
	        return result.val;
	    }

	    //
	    // Main
	    //
	    function memoize(fn, options) {
	        var cache = options && options.cache ? options.cache : cacheDefault;
	        var serializer = options && options.serializer ? options.serializer : serializerDefault;
	        var strategy = options && options.strategy ? options.strategy : strategyDefault;
	        return strategy(fn, {
	            cache: cache,
	            serializer: serializer,
	        });
	    }
	    //
	    // Strategy
	    //
	    function isPrimitive(value) {
	        return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
	    }
	    function monadic(fn, cache, serializer, arg) {
	        var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.call(this, arg);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function variadic(fn, cache, serializer) {
	        var args = Array.prototype.slice.call(arguments, 3);
	        var cacheKey = serializer(args);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.apply(this, args);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function assemble(fn, context, strategy, cache, serialize) {
	        return strategy.bind(context, fn, cache, serialize);
	    }
	    function strategyDefault(fn, options) {
	        var strategy = fn.length === 1 ? monadic : variadic;
	        return assemble(fn, this, strategy, options.cache.create(), options.serializer);
	    }
	    function strategyVariadic(fn, options) {
	        return assemble(fn, this, variadic, options.cache.create(), options.serializer);
	    }
	    function strategyMonadic(fn, options) {
	        return assemble(fn, this, monadic, options.cache.create(), options.serializer);
	    }
	    //
	    // Serializer
	    //
	    var serializerDefault = function () {
	        return JSON.stringify(arguments);
	    };
	    //
	    // Cache
	    //
	    function ObjectWithoutPrototypeCache() {
	        this.cache = Object.create(null);
	    }
	    ObjectWithoutPrototypeCache.prototype.get = function (key) {
	        return this.cache[key];
	    };
	    ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	        this.cache[key] = value;
	    };
	    var cacheDefault = {
	        create: function create() {
	            // @ts-ignore
	            return new ObjectWithoutPrototypeCache();
	        },
	    };
	    var strategies = {
	        variadic: strategyVariadic,
	        monadic: strategyMonadic,
	    };

	    var ErrorCode;
	    (function (ErrorCode) {
	        // When we have a placeholder but no value to format
	        ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
	        // When value supplied is invalid
	        ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
	        // When we need specific Intl API but it's not available
	        ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
	    })(ErrorCode || (ErrorCode = {}));
	    var FormatError = /** @class */ (function (_super) {
	        __extends(FormatError, _super);
	        function FormatError(msg, code, originalMessage) {
	            var _this = _super.call(this, msg) || this;
	            _this.code = code;
	            _this.originalMessage = originalMessage;
	            return _this;
	        }
	        FormatError.prototype.toString = function () {
	            return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
	        };
	        return FormatError;
	    }(Error));
	    var InvalidValueError = /** @class */ (function (_super) {
	        __extends(InvalidValueError, _super);
	        function InvalidValueError(variableId, value, options, originalMessage) {
	            return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueError;
	    }(FormatError));
	    var InvalidValueTypeError = /** @class */ (function (_super) {
	        __extends(InvalidValueTypeError, _super);
	        function InvalidValueTypeError(value, type, originalMessage) {
	            return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueTypeError;
	    }(FormatError));
	    var MissingValueError = /** @class */ (function (_super) {
	        __extends(MissingValueError, _super);
	        function MissingValueError(variableId, originalMessage) {
	            return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
	        }
	        return MissingValueError;
	    }(FormatError));

	    var PART_TYPE;
	    (function (PART_TYPE) {
	        PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
	        PART_TYPE[PART_TYPE["object"] = 1] = "object";
	    })(PART_TYPE || (PART_TYPE = {}));
	    function mergeLiteral(parts) {
	        if (parts.length < 2) {
	            return parts;
	        }
	        return parts.reduce(function (all, part) {
	            var lastPart = all[all.length - 1];
	            if (!lastPart ||
	                lastPart.type !== PART_TYPE.literal ||
	                part.type !== PART_TYPE.literal) {
	                all.push(part);
	            }
	            else {
	                lastPart.value += part.value;
	            }
	            return all;
	        }, []);
	    }
	    function isFormatXMLElementFn(el) {
	        return typeof el === 'function';
	    }
	    // TODO(skeleton): add skeleton support
	    function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	    // For debugging
	    originalMessage) {
	        // Hot path for straight simple msg translations
	        if (els.length === 1 && isLiteralElement(els[0])) {
	            return [
	                {
	                    type: PART_TYPE.literal,
	                    value: els[0].value,
	                },
	            ];
	        }
	        var result = [];
	        for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	            var el = els_1[_i];
	            // Exit early for string parts.
	            if (isLiteralElement(el)) {
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: el.value,
	                });
	                continue;
	            }
	            // TODO: should this part be literal type?
	            // Replace `#` in plural rules with the actual numeric value.
	            if (isPoundElement(el)) {
	                if (typeof currentPluralValue === 'number') {
	                    result.push({
	                        type: PART_TYPE.literal,
	                        value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                    });
	                }
	                continue;
	            }
	            var varName = el.value;
	            // Enforce that all required values are provided by the caller.
	            if (!(values && varName in values)) {
	                throw new MissingValueError(varName, originalMessage);
	            }
	            var value = values[varName];
	            if (isArgumentElement(el)) {
	                if (!value || typeof value === 'string' || typeof value === 'number') {
	                    value =
	                        typeof value === 'string' || typeof value === 'number'
	                            ? String(value)
	                            : '';
	                }
	                result.push({
	                    type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                    value: value,
	                });
	                continue;
	            }
	            // Recursively format plural and select parts' option — which can be a
	            // nested pattern structure. The choosing of the option to use is
	            // abstracted-by and delegated-to the part helper object.
	            if (isDateElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.date[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTimeElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.time[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : formats.time.medium;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isNumberElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.number[el.style]
	                    : isNumberSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                if (style && style.scale) {
	                    value =
	                        value *
	                            (style.scale || 1);
	                }
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getNumberFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTagElement(el)) {
	                var children = el.children, value_1 = el.value;
	                var formatFn = values[value_1];
	                if (!isFormatXMLElementFn(formatFn)) {
	                    throw new InvalidValueTypeError(value_1, 'function', originalMessage);
	                }
	                var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
	                var chunks = formatFn(parts.map(function (p) { return p.value; }));
	                if (!Array.isArray(chunks)) {
	                    chunks = [chunks];
	                }
	                result.push.apply(result, chunks.map(function (c) {
	                    return {
	                        type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                        value: c,
	                    };
	                }));
	            }
	            if (isSelectElement(el)) {
	                var opt = el.options[value] || el.options.other;
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	                continue;
	            }
	            if (isPluralElement(el)) {
	                var opt = el.options["=".concat(value)];
	                if (!opt) {
	                    if (!Intl.PluralRules) {
	                        throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
	                    }
	                    var rule = formatters
	                        .getPluralRules(locales, { type: el.pluralType })
	                        .select(value - (el.offset || 0));
	                    opt = el.options[rule] || el.options.other;
	                }
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	                continue;
	            }
	        }
	        return mergeLiteral(result);
	    }

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    // -- MessageFormat --------------------------------------------------------
	    function mergeConfig(c1, c2) {
	        if (!c2) {
	            return c1;
	        }
	        return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	            all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
	            return all;
	        }, {}));
	    }
	    function mergeConfigs(defaultConfig, configs) {
	        if (!configs) {
	            return defaultConfig;
	        }
	        return Object.keys(defaultConfig).reduce(function (all, k) {
	            all[k] = mergeConfig(defaultConfig[k], configs[k]);
	            return all;
	        }, __assign({}, defaultConfig));
	    }
	    function createFastMemoizeCache(store) {
	        return {
	            create: function () {
	                return {
	                    get: function (key) {
	                        return store[key];
	                    },
	                    set: function (key, value) {
	                        store[key] = value;
	                    },
	                };
	            },
	        };
	    }
	    function createDefaultFormatters(cache) {
	        if (cache === void 0) { cache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        }; }
	        return {
	            getNumberFormat: memoize(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.number),
	                strategy: strategies.variadic,
	            }),
	            getDateTimeFormat: memoize(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.dateTime),
	                strategy: strategies.variadic,
	            }),
	            getPluralRules: memoize(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.pluralRules),
	                strategy: strategies.variadic,
	            }),
	        };
	    }
	    var IntlMessageFormat = /** @class */ (function () {
	        function IntlMessageFormat(message, locales, overrideFormats, opts) {
	            var _this = this;
	            if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	            this.formatterCache = {
	                number: {},
	                dateTime: {},
	                pluralRules: {},
	            };
	            this.format = function (values) {
	                var parts = _this.formatToParts(values);
	                // Hot path for straight simple msg translations
	                if (parts.length === 1) {
	                    return parts[0].value;
	                }
	                var result = parts.reduce(function (all, part) {
	                    if (!all.length ||
	                        part.type !== PART_TYPE.literal ||
	                        typeof all[all.length - 1] !== 'string') {
	                        all.push(part.value);
	                    }
	                    else {
	                        all[all.length - 1] += part.value;
	                    }
	                    return all;
	                }, []);
	                if (result.length <= 1) {
	                    return result[0] || '';
	                }
	                return result;
	            };
	            this.formatToParts = function (values) {
	                return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	            };
	            this.resolvedOptions = function () { return ({
	                locale: _this.resolvedLocale.toString(),
	            }); };
	            this.getAst = function () { return _this.ast; };
	            // Defined first because it's used to build the format pattern.
	            this.locales = locales;
	            this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
	            if (typeof message === 'string') {
	                this.message = message;
	                if (!IntlMessageFormat.__parse) {
	                    throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	                }
	                // Parse string messages into an AST.
	                this.ast = IntlMessageFormat.__parse(message, {
	                    ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
	                    locale: this.resolvedLocale,
	                });
	            }
	            else {
	                this.ast = message;
	            }
	            if (!Array.isArray(this.ast)) {
	                throw new TypeError('A message must be provided as a String or AST.');
	            }
	            // Creates a new object with the specified `formats` merged with the default
	            // formats.
	            this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	            this.formatters =
	                (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	        }
	        Object.defineProperty(IntlMessageFormat, "defaultLocale", {
	            get: function () {
	                if (!IntlMessageFormat.memoizedDefaultLocale) {
	                    IntlMessageFormat.memoizedDefaultLocale =
	                        new Intl.NumberFormat().resolvedOptions().locale;
	                }
	                return IntlMessageFormat.memoizedDefaultLocale;
	            },
	            enumerable: false,
	            configurable: true
	        });
	        IntlMessageFormat.memoizedDefaultLocale = null;
	        IntlMessageFormat.resolveLocale = function (locales) {
	            var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
	            if (supportedLocales.length > 0) {
	                return new Intl.Locale(supportedLocales[0]);
	            }
	            return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
	        };
	        IntlMessageFormat.__parse = parse;
	        // Default format options used as the prototype of the `formats` provided to the
	        // constructor. These are used when constructing the internal Intl.NumberFormat
	        // and Intl.DateTimeFormat instances.
	        IntlMessageFormat.formats = {
	            number: {
	                integer: {
	                    maximumFractionDigits: 0,
	                },
	                currency: {
	                    style: 'currency',
	                },
	                percent: {
	                    style: 'percent',
	                },
	            },
	            date: {
	                short: {
	                    month: 'numeric',
	                    day: 'numeric',
	                    year: '2-digit',
	                },
	                medium: {
	                    month: 'short',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                long: {
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                full: {
	                    weekday: 'long',
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	            },
	            time: {
	                short: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                },
	                medium: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                },
	                long: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	                full: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	            },
	        };
	        return IntlMessageFormat;
	    }());

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    var o = IntlMessageFormat;

	    const r={},i=(e,n,t)=>t?(n in r||(r[n]={}),e in r[n]||(r[n][e]=t),t):t,a=(e,n)=>{if(null==n)return;if(n in r&&e in r[n])return r[n][e];const t=E(n);for(let o=0;o<t.length;o++){const r=c(t[o],e);if(r)return i(e,n,r)}};let l;const s=writable({});function u(e){return e in l}function c(e,n){if(!u(e))return null;return function(e,n){if(n in e)return e[n];const t=n.split(".");let o=e;for(let e=0;e<t.length;e++)if("object"==typeof o){if(e>0){const n=t.slice(e,t.length).join(".");if(n in o){o=o[n];break}}o=o[t[e]];}else o=void 0;return o}(function(e){return l[e]||null}(e),n)}function m(e,...n){delete r[e],s.update((o=>(o[e]=cjs.all([o[e]||{},...n]),o)));}derived([s],(([e])=>Object.keys(e)));s.subscribe((e=>l=e));const d={};function g(e){return d[e]}function w(e){return E(e).some((e=>{var n;return null===(n=g(e))||void 0===n?void 0:n.size}))}function h(e,n){return Promise.all(n.map((n=>(function(e,n){d[e].delete(n),0===d[e].size&&delete d[e];}(e,n),n().then((e=>e.default||e)))))).then((n=>m(e,...n)))}const p={};function b(e){if(!w(e))return e in p?p[e]:void 0;const n=function(e){return E(e).map((e=>{const n=g(e);return [e,n?[...n]:[]]})).filter((([,e])=>e.length>0))}(e);return p[e]=Promise.all(n.map((([e,n])=>h(e,n)))).then((()=>{if(w(e))return b(e);delete p[e];})),p[e]}/*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */function v(e,n){var t={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)n.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(t[o[r]]=e[o[r]]);}return t}const O={fallbackLocale:null,initialLocale:null,loadingDelay:200,formats:{number:{scientific:{notation:"scientific"},engineering:{notation:"engineering"},compactLong:{notation:"compact",compactDisplay:"long"},compactShort:{notation:"compact",compactDisplay:"short"}},date:{short:{month:"numeric",day:"numeric",year:"2-digit"},medium:{month:"short",day:"numeric",year:"numeric"},long:{month:"long",day:"numeric",year:"numeric"},full:{weekday:"long",month:"long",day:"numeric",year:"numeric"}},time:{short:{hour:"numeric",minute:"numeric"},medium:{hour:"numeric",minute:"numeric",second:"numeric"},long:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"},full:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"}}},warnOnMissingMessages:!0,ignoreTag:!0};function j(){return O}function $(e){const{formats:n}=e,t=v(e,["formats"]),o=e.initialLocale||e.fallbackLocale;return Object.assign(O,t,{initialLocale:o}),n&&("number"in n&&Object.assign(O.formats.number,n.number),"date"in n&&Object.assign(O.formats.date,n.date),"time"in n&&Object.assign(O.formats.time,n.time)),T.set(o)}const k=writable(!1);let L;const T=writable(null);function x(e){return e.split("-").map(((e,n,t)=>t.slice(0,n+1).join("-"))).reverse()}function E(e,n=j().fallbackLocale){const t=x(e);return n?[...new Set([...t,...x(n)])]:t}function D(){return L}T.subscribe((e=>{L=e,"undefined"!=typeof window&&null!==e&&document.documentElement.setAttribute("lang",e);}));const M=T.set;T.set=e=>{if(function(e){if(null==e)return;const n=E(e);for(let e=0;e<n.length;e++){const t=n[e];if(u(t))return t}}(e)&&w(e)){const{loadingDelay:n}=j();let t;return "undefined"!=typeof window&&null!=D()&&n?t=window.setTimeout((()=>k.set(!0)),n):k.set(!0),b(e).then((()=>{M(e);})).finally((()=>{clearTimeout(t),k.set(!1);}))}return M(e)},T.update=e=>M(e(L));const Z=e=>{const n=Object.create(null);return t=>{const o=JSON.stringify(t);return o in n?n[o]:n[o]=e(t)}},C=(e,n)=>{const{formats:t}=j();if(e in t&&n in t[e])return t[e][n];throw new Error(`[svelte-i18n] Unknown "${n}" ${e} format.`)},G=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format numbers');return t&&(o=C("number",t)),new Intl.NumberFormat(n,o)})),J=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format dates');return t?o=C("date",t):0===Object.keys(o).length&&(o=C("date","short")),new Intl.DateTimeFormat(n,o)})),U=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format time values');return t?o=C("time",t):0===Object.keys(o).length&&(o=C("time","short")),new Intl.DateTimeFormat(n,o)})),_=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return G(Object.assign({locale:n},t))},q=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return J(Object.assign({locale:n},t))},B=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return U(Object.assign({locale:n},t))},H=Z(((e,n=D())=>new o(e,n,j().formats,{ignoreTag:j().ignoreTag}))),K=(e,n={})=>{"object"==typeof e&&(e=(n=e).id);const{values:t,locale:o=D(),default:r}=n;if(null==o)throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");let i=a(e,o);if(i){if("string"!=typeof i)return console.warn(`[svelte-i18n] Message with id "${e}" must be of type "string", found: "${typeof i}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`),i}else j().warnOnMissingMessages&&console.warn(`[svelte-i18n] The message "${e}" was not found in "${E(o).join('", "')}".${w(D())?"\n\nNote: there are at least one loader still registered to this locale that wasn't executed.":""}`),i=r||e;if(!t)return i;let l=i;try{l=H(i,o).format(t);}catch(n){console.warn(`[svelte-i18n] Message "${e}" has syntax error:`,n.message);}return l},Q=(e,n)=>B(n).format(e),R=(e,n)=>q(n).format(e),V=(e,n)=>_(n).format(e),W=(e,n=D())=>a(e,n),X=derived([T,s],(()=>K));derived([T],(()=>Q));derived([T],(()=>R));derived([T],(()=>V));derived([T,s],(()=>W));

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var de = {
	      Help_Title: "PrintOS-Hilfe - {0}",
	      Help_FeedbackQuestion: "Waren diese Angaben hilfreich?",
	      Help_FeedbackDetails: "Feedback",
	      Help_FeedbackDetailsDisclaimer: "Bitte geben Sie aus Datenschutz- und Sicherheitsgründen keine persönlichen Informationen wie Ihre Telefonnummer oder E-Mail-Adresse im Kommentarbereich an.",
	      Help_FeedbackDetailsHeader: "Danke für Ihre Hilfe! Wir schätzen Ihr Feedback.",
	      Help_FeedbackDetailsQuestion: "Wie können wir dieses Thema verbessern?",
	      Help_FeedbackThanks: "Vielen Dank für Ihre Rückmeldung!",
	      Help_RetrieveError_NotFound: "Ein Fehler ist aufgetreten. Wir können dieses Dokument nicht finden.",
	      Help_RetrieveError_Unauthorized: "Ein Fehler ist aufgetreten. Sie sind nicht berechtigt, dieses Dokument anzuzeigen.",
	      Help_RetrieveError_Unknown: "Ein Fehler ist aufgetreten. Wir können dieses Dokument nicht abrufen. Versuchen Sie es später erneut.",
	      Help_Done: "Fertig"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var en = {
	      Help_Title: "PrintOS Help - {0}",
	      Help_FeedbackQuestion: "Was this information helpful?",
	      Help_FeedbackDetails: "Feedback",
	      Help_FeedbackDetailsDisclaimer: "For your privacy and security, please do not include personal information such as your phone number or email address in the comments section.",
	      Help_FeedbackDetailsHeader: "Thank you for helping us! We value your feedback.",
	      Help_FeedbackDetailsQuestion: "How can we improve this topic?",
	      Help_FeedbackThanks: "Thank you for your feedback!",
	      Help_RetrieveError_NotFound: "Sorry, something went wrong. We are unable to find this document.",
	      Help_RetrieveError_Unauthorized: "Sorry, something went wrong. You are not authorized to see this document.",
	      Help_RetrieveError_Unknown: "Sorry, something went wrong. We are unable to retrieve this document. Please try again later.",
	      Help_Done: "Done"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var es = {
	      Help_Title: "Ayuda de PrintOS - {0}",
	      Help_FeedbackQuestion: "¿Le ha sido útil esta información?",
	      Help_FeedbackDetails: "Comentarios",
	      Help_FeedbackDetailsDisclaimer: "Para garantizar su privacidad y seguridad, no incluya información personal (como su número de teléfono o dirección de correo electrónico) en la sección de comentarios.",
	      Help_FeedbackDetailsHeader: "¡Gracias por su ayuda! Apreciamos sus comentarios.",
	      Help_FeedbackDetailsQuestion: "¿Cómo podemos mejorar este tema?",
	      Help_FeedbackThanks: "¡Gracias por su retorno!",
	      Help_RetrieveError_NotFound: "Se produjo un problema. No encontramos el documento.",
	      Help_RetrieveError_Unauthorized: "Se produjo un problema. No tiene autorización para ver el documento.",
	      Help_RetrieveError_Unknown: "Se produjo un problema. No podemos recuperar el documento. Vuelva a intentarlo más tarde.",
	      Help_Done: "Listo"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var fr = {
	      Help_Title: "Guida a PrintOS - {0}",
	      Help_FeedbackQuestion: "Le informazioni sono risultate utili?",
	      Help_FeedbackDetails: "Feedback",
	      Help_FeedbackDetailsDisclaimer: "Per garantire la privacy e la sicurezza, non includere i dati personali come il numero di telefono o l'indirizzo email nella sezione Commenti.",
	      Help_FeedbackDetailsHeader: "Grazie per il tuo contributo. Apprezziamo i tuoi commenti.",
	      Help_FeedbackDetailsQuestion: "Come possiamo migliorare questo argomento?",
	      Help_FeedbackThanks: "Grazie per il feedback!",
	      Help_RetrieveError_NotFound: "Si  è verificato un errore. Impossibile trovare il documento.",
	      Help_RetrieveError_Unauthorized: "Si  è verificato un errore. Autorizzazioni mancanti per visionare il documento.",
	      Help_RetrieveError_Unknown: "Si  è verificato un errore. Impossibile trovare il documento. Riprova più tardi.",
	      Help_Done: "Fine"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var it = {
	      Help_Title: "Guida a PrintOS - {0}",
	      Help_FeedbackQuestion: "Le informazioni sono risultate utili?",
	      Help_FeedbackDetails: "Feedback",
	      Help_FeedbackDetailsDisclaimer: "Per garantire la privacy e la sicurezza, non includere i dati personali come il numero di telefono o l'indirizzo email nella sezione Commenti.",
	      Help_FeedbackDetailsHeader: "Grazie per il tuo contributo. Apprezziamo i tuoi commenti.",
	      Help_FeedbackDetailsQuestion: "Come possiamo migliorare questo argomento?",
	      Help_FeedbackThanks: "Grazie per il feedback!",
	      Help_RetrieveError_NotFound: "Si  è verificato un errore. Impossibile trovare il documento.",
	      Help_RetrieveError_Unauthorized: "Si  è verificato un errore. Autorizzazioni mancanti per visionare il documento.",
	      Help_RetrieveError_Unknown: "Si  è verificato un errore. Impossibile trovare il documento. Riprova più tardi."
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ja = {
	      Help_Title: "PrintOSヘルプ - {0}",
	      Help_FeedbackQuestion: "この情報は役に立ちましたか?",
	      Help_FeedbackDetails: "フィードバック",
	      Help_FeedbackDetailsDisclaimer: "プライバシーとセキュリティを保護するため、電話番号や電子メールアドレスなどの個人情報をコメントセクションに記入しないでください。",
	      Help_FeedbackDetailsHeader: "ご協力ありがとうございました。いただいたフィードバックを参考にさせていただきます。",
	      Help_FeedbackDetailsQuestion: "このトピックについて改善点をお聞かせください。",
	      Help_FeedbackThanks: "フィードバックをありがとうございました。",
	      Help_RetrieveError_NotFound: "問題が発生しました。このドキュメントが見つかりません。",
	      Help_RetrieveError_Unauthorized: "問題が発生しました。このドキュメントを閲覧する権限がありません。",
	      Help_RetrieveError_Unknown: "問題が発生しました。このドキュメントを取得できません。後でやり直してください。",
	      Help_Done: "完了"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ko = {
	      Help_Title: "PrintOS 도움말 - {0}",
	      Help_FeedbackQuestion: "이 정보가 유용했습니까?",
	      Help_FeedbackDetails: "피드백",
	      Help_FeedbackDetailsDisclaimer: "개인 정보 보호 및 보안을 위해 설명 섹션에 이메일 주소 또는 전화 번호와 같은 개인 정보를 입력하지 마십시오.",
	      Help_FeedbackDetailsHeader: "도움을 주셔서 감사합니다! 귀하의 피드백은 소중합니다.",
	      Help_FeedbackDetailsQuestion: "이 항목을 어떻게 개선할 수 있습니까?",
	      Help_FeedbackThanks: "피드백에 감사드립니다!",
	      Help_RetrieveError_NotFound: "죄송합니다. 문제가 발생했습니다. 이 문서를 찾을 수 없습니다.",
	      Help_RetrieveError_Unauthorized: "죄송합니다. 문제가 발생했습니다. 이 문서를 볼 수 있는 권한이 없습니다.",
	      Help_RetrieveError_Unknown: "죄송합니다. 문제가 발생했습니다. 이 문서를 검색할 수 없습니다. 나중에 다시 시도하십시오.",
	      Help_Done: "완료됨"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var pt = {
	      Help_Title: "Ajuda do PrintOS - {0}",
	      Help_FeedbackQuestion: "Essas informações foram úteis?",
	      Help_FeedbackDetails: "Feedback",
	      Help_FeedbackDetailsDisclaimer: "Para sua privacidade e segurança, não inclua informações pessoais tais como número de telefone nem endereço de e-mail na seção de comentários.",
	      Help_FeedbackDetailsHeader: "Obrigado pela ajuda! Seus comentários são importantes para nós.",
	      Help_FeedbackDetailsQuestion: "Como podemos melhorar este tópico?",
	      Help_FeedbackThanks: "Agradecemos o seu feedback",
	      Help_RetrieveError_NotFound: "Alguma coisa deu errado. Não foi possível encontrar este documento.",
	      Help_RetrieveError_Unauthorized: "Alguma coisa deu errado. Você não está autorizado a ver este documento.",
	      Help_RetrieveError_Unknown: "Alguma coisa deu errado. Não foi possível recuperar este documento. Tente de novo mais tarde.",
	      Help_Done: "Concluído"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ru = {
	      Help_Title: "Справка PrintOS - {0}",
	      Help_FeedbackQuestion: "Оказалась ли эта информация полезной?",
	      Help_FeedbackDetails: "Отзыв",
	      Help_FeedbackDetailsDisclaimer: "Для обеспечения конфиденциальности и безопасности своих данных не указывайте в разделе комментариев личные сведения, такие как номер телефона или адрес эл. почты.",
	      Help_FeedbackDetailsHeader: "Спасибо за помощь! Мы высоко ценим ваше мнение.",
	      Help_FeedbackDetailsQuestion: "Что можно улучшить?",
	      Help_FeedbackThanks: "Благодарим за отзыв!",
	      Help_RetrieveError_NotFound: "К сожалению, что-то пошло не так. Найти этот документ не удалось.",
	      Help_RetrieveError_Unauthorized: "К сожалению, что-то пошло не так. У вас нет прав на просмотр этого документа.",
	      Help_RetrieveError_Unknown: "К сожалению, что-то пошло не так. Получить этот документ не удалось. Повторите попытку позже.",
	      Help_Done: "Готово"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var zh = {
	      Help_Title: "Aide de PrintOS - {0}",
	      Help_FeedbackQuestion: "Ces informations vous ont-elles été utiles ?",
	      Help_FeedbackDetails: "Avis",
	      Help_FeedbackDetailsDisclaimer: "Pour votre confidentialité et votre sécurité, veuillez ne pas inclure de renseignements personnels, tels que votre numéro de téléphone ou votre adresse e-mail dans la section des commentaires.",
	      Help_FeedbackDetailsHeader: "Merci de nous aider ! Nous apprécions vos avis.",
	      Help_FeedbackDetailsQuestion: "Comment pouvons-nous améliorer cette rubrique ?",
	      Help_FeedbackThanks: "Merci pour votre avis !",
	      Help_RetrieveError_NotFound: "Désolé, un problème est survenu. Impossible trouver ce document.",
	      Help_RetrieveError_Unauthorized: "Désolé, un problème est survenu. Vous n’êtes pas autorisé à voir ce document.",
	      Help_RetrieveError_Unknown: "Désolé, un problème est survenu. Nous ne sommes pas en mesure de récupérer ce document. Veuillez réessayer plus tard.",
	      Help_Done: "Effectué"
	    };

	    const {
	      locale
	    } = core;
	    const dictionaryLocales = {
	      de,
	      en,
	      es,
	      fr,
	      it,
	      ja,
	      ko,
	      pt,
	      ru,
	      zh
	    };
	    s.set(dictionaryLocales);

	    // Default to the browser locale, if present
	    let browserLang = locale.getBestFit();
	    $({
	      fallbackLocale: 'en',
	      initialLocale: browserLang
	    });

	    function cubicOut(t) {
	        const f = t - 1.0;
	        return f * f * f + 1.0;
	    }

	    function slide(node, { delay = 0, duration = 400, easing = cubicOut } = {}) {
	        const style = getComputedStyle(node);
	        const opacity = +style.opacity;
	        const height = parseFloat(style.height);
	        const padding_top = parseFloat(style.paddingTop);
	        const padding_bottom = parseFloat(style.paddingBottom);
	        const margin_top = parseFloat(style.marginTop);
	        const margin_bottom = parseFloat(style.marginBottom);
	        const border_top_width = parseFloat(style.borderTopWidth);
	        const border_bottom_width = parseFloat(style.borderBottomWidth);
	        return {
	            delay,
	            duration,
	            easing,
	            css: t => 'overflow: hidden;' +
	                `opacity: ${Math.min(t * 20, 1) * opacity};` +
	                `height: ${t * height}px;` +
	                `padding-top: ${t * padding_top}px;` +
	                `padding-bottom: ${t * padding_bottom}px;` +
	                `margin-top: ${t * margin_top}px;` +
	                `margin-bottom: ${t * margin_bottom}px;` +
	                `border-top-width: ${t * border_top_width}px;` +
	                `border-bottom-width: ${t * border_bottom_width}px;`
	        };
	    }

	    /* src/HelpViewer.svelte generated by Svelte v3.38.2 */
	    function add_css() {
	      var style = element("style");
	      style.id = "svelte-18qjps3-style";
	      style.textContent = ".hp-logo.svelte-18qjps3.svelte-18qjps3{margin-right:16px}.pros-help-wrapper.svelte-18qjps3.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3.svelte-18qjps3{display:flex;flex-direction:column;height:100vh;margin:0;color:#5A5A5A;font-family:FormaDJR, sans-serif;font-size:16px;height:100%;background-color:#fdfdfd}.pros-help-wrapper.svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar,.pros-help-wrapper.svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar{width:6px;height:6px}.pros-help-wrapper.svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar-track,.pros-help-wrapper.svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar-track,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar-track,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar-track{background-color:transparent}.pros-help-wrapper.svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar-thumb,.pros-help-wrapper.svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar-thumb,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3.svelte-18qjps3::-webkit-scrollbar-thumb,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .svelte-18qjps3::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:10px}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-header.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-header.svelte-18qjps3{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;height:60px;flex-shrink:0;width:100%;padding:0 16px;color:#FFFFFF;background-color:#212121}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-header .pros-help-button-wrapper.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-header .pros-help-button-wrapper.svelte-18qjps3{cursor:pointer;margin-left:auto;margin-right:0}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-content.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-content.svelte-18qjps3{display:flex;flex:1;box-sizing:border-box;min-height:0}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-content .material.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-content .material.svelte-18qjps3{flex:1;width:100%;border:none}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-content .pros-help-viewer-video.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-content .pros-help-viewer-video.svelte-18qjps3{display:flex;flex:1;max-height:100%}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-content .pros-help-viewer-video .pros-help-viewer-videoplayer.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-content .pros-help-viewer-video .pros-help-viewer-videoplayer.svelte-18qjps3{width:100%}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-footer.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-footer.svelte-18qjps3{display:flex;flex-direction:row;align-items:center;justify-content:center;border-top:1px solid #CCCCCC;padding:0 16px;height:64px}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-footer .pros-help-viewer-help-feedback.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-footer .pros-help-viewer-help-feedback.svelte-18qjps3{font-size:24px;font-weight:400;color:#FFFFFF}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-footer .feedback-image.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-footer .feedback-image.svelte-18qjps3{margin:auto;background-repeat:no-repeat;display:inline-block;vertical-align:middle;fill:currentColor;margin:0 16px;cursor:pointer}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-footer .feedback-image.up.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-footer .feedback-image.up.svelte-18qjps3{fill:#509137}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-footer .feedback-image.down.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-footer .feedback-image.down.svelte-18qjps3{fill:#F04B37}.pros-help-wrapper.svelte-18qjps3 .pros-help-viewer-survey-container.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-help-viewer-survey-container.svelte-18qjps3{overflow:hidden;height:64px;transition:max-height 0.5s linear;background-color:#212121}.pros-help-wrapper.svelte-18qjps3 .pros-icon.svelte-18qjps3,.pros-help-wrapper[pos--theme=dark].svelte-18qjps3 .pros-icon.svelte-18qjps3{width:24px;height:24px;line-height:24px;color:#ffffff}.pros-help-wrapper[pos--theme=light].svelte-18qjps3 .pros-help-viewer-header.svelte-18qjps3{background-color:#fdfdfd;color:#212121}.pros-help-wrapper[pos--theme=light].svelte-18qjps3 .pros-help-viewer-content.svelte-18qjps3{background-color:#ffffff;color:#212121}.pros-help-wrapper[pos--theme=light].svelte-18qjps3 .pros-help-viewer-footer.svelte-18qjps3{background-color:#ffffff}.pros-help-wrapper[pos--theme=light].svelte-18qjps3 .pros-help-viewer-footer .pros-help-viewer-help-feedback.svelte-18qjps3{color:#212121}";
	      append(document.head, style);
	    }

	    // (2:2) {#if header}
	    function create_if_block_3(ctx) {
	      let div3;
	      let div0;
	      let icon;
	      let t0;
	      let div1;
	      let t1;
	      let t2;
	      let div2;
	      let button;
	      let current;
	      icon = new Icon$1({
	        props: {
	          path: "hp-premium2.svg",
	          theme: /*theme*/ctx[1],
	          size: "36",
	          constraint: "h"
	        }
	      });
	      button = new Button({
	        props: {
	          label: /*$_*/ctx[11]("Help_Done"),
	          theme: "auto",
	          width: "160",
	          density: "high"
	        }
	      });
	      button.$on("clicked", handleClose);
	      return {
	        c() {
	          div3 = element("div");
	          div0 = element("div");
	          create_component(icon.$$.fragment);
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*_title*/ctx[12]);
	          t2 = space();
	          div2 = element("div");
	          create_component(button.$$.fragment);
	          attr(div0, "class", "hp-logo svelte-18qjps3");
	          attr(div1, "class", "help-title svelte-18qjps3");
	          attr(div2, "class", "pros-help-button-wrapper svelte-18qjps3");
	          attr(div3, "class", "pros-help-viewer-header svelte-18qjps3");
	        },
	        m(target, anchor) {
	          insert(target, div3, anchor);
	          append(div3, div0);
	          mount_component(icon, div0, null);
	          append(div3, t0);
	          append(div3, div1);
	          append(div1, t1);
	          append(div3, t2);
	          append(div3, div2);
	          mount_component(button, div2, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_changes = {};
	          if (dirty & /*theme*/2) icon_changes.theme = /*theme*/ctx[1];
	          icon.$set(icon_changes);
	          if (!current || dirty & /*_title*/4096) set_data(t1, /*_title*/ctx[12]);
	          const button_changes = {};
	          if (dirty & /*$_*/2048) button_changes.label = /*$_*/ctx[11]("Help_Done");
	          button.$set(button_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in(icon.$$.fragment, local);
	          transition_in(button.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(icon.$$.fragment, local);
	          transition_out(button.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div3);
	          destroy_component(icon);
	          destroy_component(button);
	        }
	      };
	    }

	    // (42:2) {:else}
	    function create_else_block_1(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*notFoundMessage*/ctx[7]);
	          attr(div, "class", "pros-help-viewer-error svelte-18qjps3");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*notFoundMessage*/128) set_data(t, /*notFoundMessage*/ctx[7]);
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (15:2) {#if _validType}
	    function create_if_block(ctx) {
	      let div;
	      let t;
	      let if_block1_anchor;
	      let current;
	      function select_block_type_1(ctx, dirty) {
	        if (/*tutorial*/ctx[5].type === "video") return create_if_block_2;
	        return create_else_block;
	      }
	      let current_block_type = select_block_type_1(ctx);
	      let if_block0 = current_block_type(ctx);
	      let if_block1 = /*showSurvey*/ctx[0] && create_if_block_1(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block0.c();
	          t = space();
	          if (if_block1) if_block1.c();
	          if_block1_anchor = empty();
	          attr(div, "class", "pros-help-viewer-content svelte-18qjps3");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block0.m(div, null);
	          insert(target, t, anchor);
	          if (if_block1) if_block1.m(target, anchor);
	          insert(target, if_block1_anchor, anchor);
	          current = true;
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block0) {
	            if_block0.p(ctx, dirty);
	          } else {
	            if_block0.d(1);
	            if_block0 = current_block_type(ctx);
	            if (if_block0) {
	              if_block0.c();
	              if_block0.m(div, null);
	            }
	          }
	          if (/*showSurvey*/ctx[0]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty & /*showSurvey*/1) {
	                transition_in(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_1(ctx);
	              if_block1.c();
	              transition_in(if_block1, 1);
	              if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	            }
	          } else if (if_block1) {
	            group_outros();
	            transition_out(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros();
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block0.d();
	          if (detaching) detach(t);
	          if (if_block1) if_block1.d(detaching);
	          if (detaching) detach(if_block1_anchor);
	        }
	      };
	    }

	    // (23:6) {:else}
	    function create_else_block(ctx) {
	      let iframe;
	      let iframe_src_value;
	      return {
	        c() {
	          iframe = element("iframe");
	          attr(iframe, "class", "material svelte-18qjps3");
	          if (iframe.src !== (iframe_src_value = /*tutorial*/ctx[5].content)) attr(iframe, "src", iframe_src_value);
	          attr(iframe, "title", /*_title*/ctx[12]);
	        },
	        m(target, anchor) {
	          insert(target, iframe, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*tutorial*/32 && iframe.src !== (iframe_src_value = /*tutorial*/ctx[5].content)) {
	            attr(iframe, "src", iframe_src_value);
	          }
	          if (dirty & /*_title*/4096) {
	            attr(iframe, "title", /*_title*/ctx[12]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(iframe);
	        }
	      };
	    }

	    // (17:6) {#if tutorial.type === 'video'}
	    function create_if_block_2(ctx) {
	      let div;
	      let video;
	      let source;
	      let source_src_value;
	      return {
	        c() {
	          div = element("div");
	          video = element("video");
	          source = element("source");
	          if (source.src !== (source_src_value = /*tutorial*/ctx[5].content)) attr(source, "src", source_src_value);
	          attr(source, "type", "video/mp4;codecs=\"avc1.42E01E, mp4a.40.2\"");
	          attr(source, "class", "svelte-18qjps3");
	          attr(video, "class", "pros-help-viewer-videoplayer svelte-18qjps3");
	          video.controls = true;
	          attr(video, "preload", "auto");
	          attr(div, "class", "pros-help-viewer-video svelte-18qjps3");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, video);
	          append(video, source);
	        },
	        p(ctx, dirty) {
	          if (dirty & /*tutorial*/32 && source.src !== (source_src_value = /*tutorial*/ctx[5].content)) {
	            attr(source, "src", source_src_value);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (27:4) {#if showSurvey}
	    function create_if_block_1(ctx) {
	      let div4;
	      let div3;
	      let div0;
	      let t0;
	      let t1;
	      let div1;
	      let icon0;
	      let t2;
	      let div2;
	      let icon1;
	      let div4_transition;
	      let current;
	      let mounted;
	      let dispose;
	      icon0 = new Icon$1({
	        props: {
	          path: "general/fa/thumbs-up.svg",
	          theme: /*theme*/ctx[1],
	          size: "24",
	          constraint: "h"
	        }
	      });
	      icon1 = new Icon$1({
	        props: {
	          path: "general/fa/thumbs-down.svg",
	          theme: /*theme*/ctx[1],
	          size: "24",
	          constraint: "h"
	        }
	      });
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          div0 = element("div");
	          t0 = text(/*helpFeedbackQuestion*/ctx[8]);
	          t1 = space();
	          div1 = element("div");
	          create_component(icon0.$$.fragment);
	          t2 = space();
	          div2 = element("div");
	          create_component(icon1.$$.fragment);
	          attr(div0, "class", "pros-help-viewer-help-feedback svelte-18qjps3");
	          attr(div1, "id", "thumbUpIcon");
	          attr(div1, "class", "pros-icon feedback-image up svelte-18qjps3");
	          attr(div2, "id", "thumbDownIcon");
	          attr(div2, "class", "pros-icon feedback-image down svelte-18qjps3");
	          attr(div3, "class", "pros-help-viewer-footer svelte-18qjps3");
	          attr(div4, "class", "pros-help-viewer-survey-container svelte-18qjps3");
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          append(div3, div0);
	          append(div0, t0);
	          append(div3, t1);
	          append(div3, div1);
	          mount_component(icon0, div1, null);
	          append(div3, t2);
	          append(div3, div2);
	          mount_component(icon1, div2, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div1, "click", /*thumbsUpClicked*/ctx[9]), listen(div2, "click", /*thumbsDownClicked*/ctx[10])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (!current || dirty & /*helpFeedbackQuestion*/256) set_data(t0, /*helpFeedbackQuestion*/ctx[8]);
	          const icon0_changes = {};
	          if (dirty & /*theme*/2) icon0_changes.theme = /*theme*/ctx[1];
	          icon0.$set(icon0_changes);
	          const icon1_changes = {};
	          if (dirty & /*theme*/2) icon1_changes.theme = /*theme*/ctx[1];
	          icon1.$set(icon1_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in(icon0.$$.fragment, local);
	          transition_in(icon1.$$.fragment, local);
	          add_render_callback(() => {
	            if (!div4_transition) div4_transition = create_bidirectional_transition(div4, slide, {}, true);
	            div4_transition.run(1);
	          });
	          current = true;
	        },
	        o(local) {
	          transition_out(icon0.$$.fragment, local);
	          transition_out(icon1.$$.fragment, local);
	          if (!div4_transition) div4_transition = create_bidirectional_transition(div4, slide, {}, false);
	          div4_transition.run(0);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div4);
	          destroy_component(icon0);
	          destroy_component(icon1);
	          if (detaching && div4_transition) div4_transition.end();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function create_fragment(ctx) {
	      let div;
	      let t;
	      let current_block_type_index;
	      let if_block1;
	      let current;
	      let if_block0 = /*header*/ctx[6] && create_if_block_3(ctx);
	      const if_block_creators = [create_if_block, create_else_block_1];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*_validType*/ctx[4]) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      return {
	        c() {
	          div = element("div");
	          if (if_block0) if_block0.c();
	          t = space();
	          if_block1.c();
	          attr(div, "class", "pros-help-wrapper svelte-18qjps3");
	          attr(div, "pos--theme", /*_theme*/ctx[3]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if (if_block0) if_block0.m(div, null);
	          append(div, t);
	          if_blocks[current_block_type_index].m(div, null);
	          /*div_binding*/
	          ctx[17](div);
	          current = true;
	        },
	        p(ctx, [dirty]) {
	          if (/*header*/ctx[6]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty & /*header*/64) {
	                transition_in(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_3(ctx);
	              if_block0.c();
	              transition_in(if_block0, 1);
	              if_block0.m(div, t);
	            }
	          } else if (if_block0) {
	            group_outros();
	            transition_out(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros();
	          }
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros();
	            transition_out(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros();
	            if_block1 = if_blocks[current_block_type_index];
	            if (!if_block1) {
	              if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block1.c();
	            } else {
	              if_block1.p(ctx, dirty);
	            }
	            transition_in(if_block1, 1);
	            if_block1.m(div, null);
	          }
	          if (!current || dirty & /*_theme*/8) {
	            attr(div, "pos--theme", /*_theme*/ctx[3]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block0);
	          transition_in(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block0);
	          transition_out(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if (if_block0) if_block0.d();
	          if_blocks[current_block_type_index].d();
	          /*div_binding*/
	          ctx[17](null);
	        }
	      };
	    }
	    function hasValue(test) {
	      return test !== undefined && test !== null;
	    }
	    function handleClose() {
	      window.close();
	    }
	    function instance($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(11, $_ = $$value));
	      createEventDispatcher();
	      let {
	        tutorial
	      } = $$props;
	      let {
	        header = false
	      } = $$props;
	      let {
	        showSurvey = false
	      } = $$props;
	      let {
	        theme = "light"
	      } = $$props; // auto, light, dark
	      let {
	        _helpViewerLayoutElement
	      } = $$props;
	      let {
	        _theme
	      } = $$props;
	      let {
	        _lastTheme
	      } = $$props;
	      let {
	        _themeEventListener
	      } = $$props;
	      let {
	        _printos
	      } = $$props;
	      let {
	        _validType
	      } = $$props;
	      let {
	        notFoundMessage = $_("Help_RetrieveError_NotFound")
	      } = $$props;
	      let {
	        helpFeedbackQuestion = $_("Help_FeedbackQuestion")
	      } = $$props;
	      let _title;
	      function thumbsUpClicked(event) {
	        event.stopPropagation();
	        $$invalidate(0, showSurvey = false);
	        if (_printos) {
	          _printos.ga.v1.eventTrack("home", "Help Feedback Good", tutorial.analyticsTitle);
	          _printos.ui.v0.toast({
	            title: $_("Help_FeedbackThanks")
	          });
	        }
	      }
	      function thumbsDownClicked(event) {
	        event.stopPropagation();
	        $$invalidate(0, showSurvey = false);
	        if (_printos) {
	          _printos.ga.v1.eventTrack("home", "Help Feedback Bad", tutorial.analyticsTitle);
	          _printos.ui.v0.toast({
	            title: $_("Help_FeedbackThanks")
	          });
	        }
	      }
	      onMount(() => {
	        // Parent must have position relative to ensure proper sizing with "absolute reset" sizing trick
	        $$invalidate(2, _helpViewerLayoutElement.parentElement.style.position = "relative", _helpViewerLayoutElement);
	        $$invalidate(2, _helpViewerLayoutElement.parentElement.style.display = "block", _helpViewerLayoutElement);
	        $$invalidate(2, _helpViewerLayoutElement.parentElement.style.width = "100%", _helpViewerLayoutElement);
	        $$invalidate(2, _helpViewerLayoutElement.parentElement.style.height = "100%", _helpViewerLayoutElement);

	        // Only show survey if header is intact
	        if (window.document.body.getAttribute("printos-app") !== null) {
	          // are we in a PrintOS environment
	          $$invalidate(15, _printos = window.$printos);
	          $$invalidate(0, showSurvey = true);
	        } else {
	          $$invalidate(0, showSurvey = false);
	        }
	        const validTypes = ["pdf", "url", "freshdesk", "video"];
	        $$invalidate(4, _validType = validTypes.includes(tutorial.type));
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        $$invalidate(1, theme = hasValue(theme) ? theme : "light");
	        if (theme !== _lastTheme) {
	          $$invalidate(13, _lastTheme = theme);
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(3, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              $$invalidate(14, _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(3, _theme = event.detail.theme);
	                }
	              }));
	            }
	          } else {
	            $$invalidate(3, _theme = theme);
	          }
	        }
	      });
	      function div_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _helpViewerLayoutElement = $$value;
	          $$invalidate(2, _helpViewerLayoutElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("tutorial" in $$props) $$invalidate(5, tutorial = $$props.tutorial);
	        if ("header" in $$props) $$invalidate(6, header = $$props.header);
	        if ("showSurvey" in $$props) $$invalidate(0, showSurvey = $$props.showSurvey);
	        if ("theme" in $$props) $$invalidate(1, theme = $$props.theme);
	        if ("_helpViewerLayoutElement" in $$props) $$invalidate(2, _helpViewerLayoutElement = $$props._helpViewerLayoutElement);
	        if ("_theme" in $$props) $$invalidate(3, _theme = $$props._theme);
	        if ("_lastTheme" in $$props) $$invalidate(13, _lastTheme = $$props._lastTheme);
	        if ("_themeEventListener" in $$props) $$invalidate(14, _themeEventListener = $$props._themeEventListener);
	        if ("_printos" in $$props) $$invalidate(15, _printos = $$props._printos);
	        if ("_validType" in $$props) $$invalidate(4, _validType = $$props._validType);
	        if ("notFoundMessage" in $$props) $$invalidate(7, notFoundMessage = $$props.notFoundMessage);
	        if ("helpFeedbackQuestion" in $$props) $$invalidate(8, helpFeedbackQuestion = $$props.helpFeedbackQuestion);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty & /*$_, tutorial*/2080) {
	          $$invalidate(12, _title = $_("Help_Title", {
	            values: {
	              0: tutorial.title
	            }
	          }));
	        }
	      };
	      return [showSurvey, theme, _helpViewerLayoutElement, _theme, _validType, tutorial, header, notFoundMessage, helpFeedbackQuestion, thumbsUpClicked, thumbsDownClicked, $_, _title, _lastTheme, _themeEventListener, _printos, hasValue, div_binding];
	    }
	    class HelpViewer extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-18qjps3-style")) add_css();
	        init(this, options, instance, create_fragment, safe_not_equal, {
	          tutorial: 5,
	          header: 6,
	          showSurvey: 0,
	          theme: 1,
	          _helpViewerLayoutElement: 2,
	          _theme: 3,
	          _lastTheme: 13,
	          _themeEventListener: 14,
	          _printos: 15,
	          _validType: 4,
	          notFoundMessage: 7,
	          helpFeedbackQuestion: 8,
	          thumbsUpClicked: 9,
	          thumbsDownClicked: 10,
	          hasValue: 16
	        });
	      }
	      get thumbsUpClicked() {
	        return this.$$.ctx[9];
	      }
	      get thumbsDownClicked() {
	        return this.$$.ctx[10];
	      }
	      get hasValue() {
	        return hasValue;
	      }
	    }

	    exports.HelpViewer = HelpViewer;

	    Object.defineProperty(exports, '__esModule', { value: true });

	})));
	});

	var name = 'prosHelpViewer';
	function prosHelpViewer() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      tutorial: '=',
	      theme: '@',
	      header: '=?'
	    },
	    link: helpViewerLink,
	    controller: helpViewerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function helpViewerLink(scope, element, attrs) {
	    var header = hasValue(scope.vm.header) ? scope.vm.header : attrs.hasOwnProperty('header');
	    var props = {
	      id: scope.vm.id,
	      tutorial: scope.vm.tutorial,
	      theme: scope.vm.theme,
	      header: header
	    };
	    if (scope.vm.showSurvey != undefined) {
	      props['showSurvey'] = scope.vm.showSurvey;
	    }
	    scope.vm.helpViewer = new helpViewer.HelpViewer({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.helpViewer.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.tutorial', function (tutorial) {
	      scope.vm.helpViewer.$set({
	        tutorial: tutorial
	      });
	    });
	    scope.$watch('vm.header', function (header) {
	      if (hasValue(scope.vm.header)) {
	        scope.vm.helpViewer.$set({
	          header: header
	        });
	      }
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.helpViewer.$set({
	        theme: theme
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.helpViewer.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function helpViewerController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var helpViewer_module = angular.module('printos.help-viewer', []).directive(name, prosHelpViewer).name;

	return helpViewer_module;

})));
